import axios from 'axios';
import React, { Component } from 'react';
import Footer from './Footer';
import Header from './Header';
import ReactDOM from "react-dom";
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import { BallClipRotate } from 'react-pure-loaders';
import { jsx, css, Global, ClassNames } from '@emotion/core'
import './css/Managebankaccount.css'
import { Button, Modal } from 'react-bootstrap';
import { MDBDataTable } from 'mdbreact';
import $ from 'jquery';

class Managebankaccount extends Component {

  //#region constructor
  constructor(props) {
    super(props)
    //console.log(React.version);
    this.state = {
      loading: true,
      step: 1,
      manageAccounts: '',
      errorMsg: '',
      payload: '',

      // PI web service flags
      clientID: '',
      ErrorCode: 0,
      ErrorMessage: '',
      sessionID: '',
      requestColumns: [],
      verifiedColumns: [],
      ProvinceList: [],
      getBankList: [],

      currencyList: [],
      countryList: [],

      requestID: '',
      payeeName: '',
      accountType: '',
      payeeEmail: '',
      currency: '',
      nickname: '',
      txtCount: '',
      headerTitle: '',
      entityName:'',

      // Approval Flag
      RemainingApproveCount: '',
      IsApprovalModel: '',
      IsUserAllowdToApprove: '',
      ApprovedCount: '',
      ErrMessage: '',

      respayload: '',
      txtSearchLookUpBankDetails: '',

      countryCode: '',
      isOpen: false,

      value: '',
      showModal: false,
      bankData: [],
      IsPayeeintiate: false

    }
    this.handleChange = this.handleChange.bind(this);
  }
  //#endregion

  SelectBankDetail(ROUTINGCODE, ROUTINGTYPE, NAME, ADDRESS1, CITY, PROVINCE, COUNTRY, POSTCODE, BANK_CODE, ADDRESS2) {
    let bankCode = "001";
    bankCode = document.getElementById("RoutingType").value != 9 ? BANK_CODE : (BANK_CODE.length > 3 ? BANK_CODE.substring(1, 4) : BANK_CODE)

    if (document.getElementById("RoutingType").value == "1") {
      document.getElementById("txt_SwiftCode").value = ROUTINGCODE;
      document.getElementById("txt_BankCode").value = bankCode;
    }
    if (document.getElementById("RoutingType").value == "9") {
      document.getElementById("txt_SwiftCode").value = ROUTINGCODE;
      document.getElementById("txt_BankCode").value = bankCode;
    }
    if (document.getElementById("RoutingType").value == "10") {
      document.getElementById("txt_SwiftCode").value = ROUTINGCODE + bankCode;
    }

    var payeeBankName = document.getElementById("txt_PayeeBankName");
    if (payeeBankName != null) {
      document.getElementById("txt_PayeeBankName").value = NAME;
    }

    var payeeAddress1 = document.getElementById("txt_PayeeAddress1");
    if (payeeAddress1 != null) {
      document.getElementById("txt_PayeeAddress1").value = ADDRESS1;
    }

    var payeeBankAddress2 = document.getElementById("txt_PayeeBankAddress2");
    if (payeeBankAddress2 != null) {
      document.getElementById("txt_PayeeBankAddress2").value = ADDRESS2;
    }

    var payeeBankCity = document.getElementById("txt_PayeeBankCity");
    if (payeeBankCity != null) {
      document.getElementById("txt_PayeeBankCity").value = CITY;
    }

    var bankProvency = document.getElementById("txt_BankProvency");
    if (bankProvency != null) {
      document.getElementById("txt_BankProvency").value = PROVINCE;
    }

    var postalBankCode = document.getElementById("txt_PostalBankCode");
    if (postalBankCode != null) {
      document.getElementById("txt_PostalBankCode").value = POSTCODE;
    }

    this.hideModal()
  }

  ShowBankDetailLookup = () => {
    debugger;
    let bankCode = "001";

    let bankDetailData = this.state.getBankList.map((detail, index) => (
      {

        SELECT: <div style={{ width: '60px' }}>
          <button
            className="btn btn-primary"
            title="Select"
            data-id={detail.ID}
            onClick={() => this.SelectBankDetail(detail.ROUTINGCODE, detail.ROUTINGTYPE, detail.NAME, detail.ADDRESS1, detail.CITY, detail.PROVINCE, detail.COUNTRY, detail.POSTCODE, detail.BANK_CODE, detail.ADDRESS2)}
          >Select</button></div>,
        Bank: <div style={{ width: '' }}>
          <label>{detail.NAME = "" ? "" : detail.NAME}</label> <br></br>
          <label>{detail.ADDRESS1 = "" ? "" : detail.ADDRESS1}</label><br></br>
          <label>{detail.CITY = "" ? "" : detail.CITY}</label> <br></br>
          <label>{detail.COUNTRY_NAME = "" ? "" : detail.COUNTRY_NAME}</label>
        </div>,

        BankCode: <div style={{ width: '' }}>
          <label>{detail.ROUTINGCODE = "" ? "" : detail.ROUTINGCODE}</label> &nbsp;
          <label>{document.getElementById("RoutingType").value != 9 ? detail.BANK_CODE : (detail.BANK_CODE.length > 3 ? detail.BANK_CODE.substring(1, 4) : detail.BANK_CODE)}</label>
        </div>,

        NAME: detail.NAME,
        ROUTINGCODE: detail.ROUTINGCODE,
        BANK_CODE: document.getElementById("RoutingType").value != 9 ? detail.BANK_CODE : (detail.BANK_CODE.length > 3 ? detail.BANK_CODE.substring(1, 4) : detail.BANK_CODE),
        COUNTRY_NAME: detail.COUNTRY_NAME,
        ADDRESS1: detail.ADDRESS1,
        CITY: detail.CITY,
        PROVINCE: detail.PROVINCE,
        POSTCODE: detail.POSTCODE,
        RoutingTypeNameNotNull: detail.RoutingTypeNameNotNull,
      }));

    this.setState({ bankData: bankDetailData })
    this.setState({ showModal: true })
  }

  hideModal = () => {
    this.setState({ showModal: false })
  }

  //#region componentDidMount
  componentDidMount() {

    debugger;


    var PISessionID = this.props.location.state.sessionID
    var rID = this.props.location.state.requestID

    this.setState({ sessionID: this.props.location.state.sessionID });
    this.setState({ requestID: this.props.location.state.requestID });
    this.setState({ clientID: this.props.location.state.entityID });
    this.setState({ payeeName: this.props.location.state.payeeName });
    this.setState({ entityName: this.props.location.state.entityName });
    this.setState({ currency: this.props.location.state.currency });
    this.setState({ nickname: this.props.location.state.nickname });
    this.setState({ payeeEmail: this.props.location.state.payeeEmail });
    this.setState({ countryCode: this.props.location.state.countryCode });
    

    // Get Country
    this.GetCountry();
    // Get Currency
    this.GetCurrency();

    this.IsValidatePayeeUserApproval();

    if (PISessionID == undefined || PISessionID == null) {
      // alert('Initiate');
      this.PayeeInitiate()
    }
    else {
      // alert('Call_Post');
      this.Call_Post()
    }

  }
  //#endregion  

  handleChange(event) {
    this.setState({ value: event.target.value });
  }

  CreateLookupBankDetailDynamic = () => {

    let table = []
    var hdnRoutingType = document.getElementById("RoutingType");
    if (hdnRoutingType != null) {
      var RoutingType = hdnRoutingType.value;
    }

    if (this.state.getBankList != null && this.state.getBankList != 'undefined' && this.state.getBankList.length > 0) {
      for (let i = 0; i < this.state.getBankList.length; i++) {
        var bankCode = "001";
        if (RoutingType == "9") {
          if (this.state.getBankList[i].BANK_CODE.length > 3) {
            bankCode = this.state.getBankList[i].BANK_CODE.substring(1, 4);
          } else { bankCode = this.state.getBankList[i].BANK_CODE; }

        } else {
          bankCode = this.state.getBankList[i].BANK_CODE;
        }
        table.push(
          <tr>
            {/* <td>
             
                <a href="#" class="btn btn-primary pull-right" onclick="PopulateBank(\'' + Table.ROUTINGCODE + '\',\'' + Table.ROUTINGTYPE + '\',\'' + Table.NAME + '\',\'' + Table.ADDRESS1 + '\',\'' + Table.CITY + '\',\'' + Table.PROVINCE + '\',\'' + Table.COUNTRY + '\',\'' + Table.POSTCODE + '\',\'' + bankCode + '\',\'' + Table.ADDRESS2 + '\');">Select</a>
             
            </td> */}
            <td> Select</td>
            <td> {this.state.getBankList[i].NAME}   </td>
            <td> {this.state.getBankList[i].ROUTINGCODE}  </td>
            <td> {bankCode} </td>
            <td> {this.state.getBankList[i].COUNTRY_NAME}   </td>
            <td> {this.state.getBankList[i].ADDRESS1} </td>
            <td> {this.state.getBankList[i].CITY}   </td>
            <td> {this.state.getBankList[i].PROVINCE}  </td>
            <td> {this.state.getBankList[i].POSTCODE}  </td>
            <td> {this.state.getBankList[i].RoutingTypeNameNotNull} </td>
          </tr>
        );
      }
    }
    return table;
  }

  HideAdvSearch = () => {
    this.LookUpBankDetailList();
  }

  LookUpBankDetailModelPopup(data) {

    confirmAlert({
      customUI: ({ onClose }) => {

        return (



          <div class="content-wrapper">
            <div class="card">
              <div class="card-body">
                <div className="py-2" style={{ backgroundColor: "#0073ae", padding: "10px", marginBottom: "15px", marginTop: "-25px", marginLeft: "-30px", marginRight: "-30px", fontSize: "20px" }}>
                  <p className="mb-0 text-white"><b>Lookup Bank Detail</b></p>
                </div>
                <div class="row">
                  <div class="form-group">
                    <div class="input-group">

                      <input type="text" class="form-control" style={{ width: "300px" }} placeholder="quick search like - routing code,bank code,bank name,city,country,province" ari
                        a-label=" quick search like - routing code,bank code,bank name,city,country,province" />
                      <div class="input-group-append">
                        <button class="btn btn-sm btn-primary" type="button">Search</button>
                      </div>
                    </div>
                  </div>

                  <div class="col-12">
                    <div class="table-responsive">
                      <table id="order-listing" class="table">
                        <thead>
                          <tr>
                            <th>Select</th>
                            <th>Bank Name</th>
                            <th>Routing Code</th>
                            <th>Bank Code</th>
                            <th>Country</th>
                            <th>Address 1</th>
                            <th>City</th>
                            <th>Province</th>
                            <th>Post Code</th>
                            <th>Routing Type</th>
                          </tr>
                        </thead>
                        <tbody>
                          {data.map((element) => {
                            return (
                              <tr><td>test</td><td>test</td><td>test</td><td>test</td><td>test</td><td>test</td><td>test</td><td>test</td>
                              </tr>
                            )
                          }
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>


        );
      }
    });

  }

  LookUpBankDetailList = () => {

    var hdnRoutingType = document.getElementById("RoutingType");
    var RoutingType = hdnRoutingType.value;

     // Authentication using Auth Code - AON Start
   const AuthStr = 'X-Token '.concat(this.props.location.state.requestID); 
   const authAxios = axios.create({  
    baseURL: axios.defaults.baseURL,
    headers: {         
        'Authorization': AuthStr
    },
   });
   // Authentication using Auth Code - AON End

    const URL = '/PayeePortal/LookUpBankDetailList?quickSearch=&routingType=' + RoutingType + '&countryCode=' + this.state.countryCode + '';
    authAxios.get(URL)
      .then(response => {
        if(response.data.mainCoreRes !=undefined && response.data.mainCoreRes.userMessage == "Expired Token")
          {
            this.props.history.push('/Timeout');
          }
          else{
        this.setState({ getBankList: response.data.objBankDetailResponse.getBankList.Table })
        this.ShowBankDetailLookup();
          }
                 
      })
      .catch(error => {
        this.setState({ errorMsg: 'LookUpBankDetailList: Some error occured, Please try again later.' })
        console.log(error + '-->' + this.state.errorMsg);
      })




    // confirmAlert({
    //   customUI: ({ onClose }) => {
    //     return (
    //       <div className='custom-ui'>
    //         <h1>Are you sure?</h1>
    //         <p>You want to delete this file?</p>
    //         <button onClick={onClose}>No</button>
    //         <button
    //           onClick={() => {
    //             this.handleClickDelete();
    //             onClose();
    //           }}
    //         >
    //           Yes, Delete it!
    //         </button>
    //       </div>
    //     );
    //   }
    // });

  }

  nextStep = () => {

    const { step } = this.state;
    const value = step + 1;
    this.setState({
      step: value
    });

    if (value === 1) {
      this.setState({ headerTitle: "Name & Account Number" });
    }
    else if (value === 2) {
      this.setState({ headerTitle: "Bank Information" });
    }
    else if (value === 3) {
      this.setState({ headerTitle: "Additional Information" });
    }
  }

  prevStep = () => {
    const { step } = this.state;
    const value = step - 1;
    this.setState({
      step: value
    });

    if (value === 1) {
      this.setState({ headerTitle: "Name & Account Number" });
    }
    else if (value === 2) {
      this.setState({ headerTitle: "Bank Account Number / Your Address" });
    }
    else if (value === 3) {
      this.setState({ headerTitle: "Bank Address & Other Info." });
    }
  }

  getPayload = () => {

    if (this.state.respayload == "") {
      var reqColumn = '{ "ErrorCode": 0,  "ErrorMessage": null,  "SessionId": "' + this.props.location.state.sessionID + '",  "ClientId": "' + this.props.location.state.entityID + '",  "requestColumns": null';
      reqColumn += ', "verifiedColumns": null}';
      return reqColumn;
    } else {
      var reqColumn = '{ "ErrorCode": 0,  "ErrorMessage": null,  "SessionId": "' + this.state.sessionID + '",  "ClientId": "' + this.state.clientID + '",  "requestColumns": [';

      var domElements = document.getElementsByClassName("loop-elment");


      for (var i = 0; i < domElements.length; i++) {
        //      var test=timestamps[i].innerHTML
        if (domElements[i].id.match("^txt_")) {
          reqColumn += ' {"ColumnName": "' + domElements[i].title + '","ColumnID": "' + domElements[i].id.replace('txt_', '') + '","Value": "' + domElements[i].value.replace(',', '') + '",' + '"DataType": "String","ValueRequired": true, "SampleValue": ""},';
        }
      }

      reqColumn = reqColumn.substring(0, reqColumn.length - 1);
      reqColumn += '], "verifiedColumns": null}';
    }
    return reqColumn;
  }

  IsValidatePayeeUserApproval = () => {
    // Authentication using Auth Code - AON Start
    const AuthStr = 'X-Token '.concat(this.props.location.state.requestID);
    const authAxios = axios.create({
      baseURL: axios.defaults.baseURL,
      headers: {
        'Authorization': AuthStr
      },
    });
    // Authentication using Auth Code - AON End
    const URL = '/PayeePortal/IsValidatePayeeUserApproval?payeeUserId=&moduleId=11406';
    authAxios.get(URL)
      .then(response => {
        debugger;
        if (response.data.mainCoreRes != undefined && response.data.mainCoreRes.userMessage == "Expired Token") {
          this.props.history.push('/Timeout');
        }
        else {
          this.setState({ RemainingApproveCount: response.data.objValidateApproval.RemainingApproveCount })
          this.setState({ IsApprovalModel: response.data.objValidateApproval.IsApprovalModel })
          this.setState({ IsUserAllowdToApprove: response.data.objValidateApproval.IsUserAllowdToApprove })
          this.setState({ ApprovedCount: response.data.objValidateApproval.ApprovedCount })
          this.setState({ ErrMessage: response.data.objValidateApproval.ErrMessage })
        }
      })
      .catch(error => {
        this.setState({ errorMsg: 'IsValidatePayeeUserApproval: Some error occured, Please try again later.' })
        console.log(error + '-->' + this.state.errorMsg);
      })
  }

  GetCountry = () => {
    // Authentication using Auth Code - AON Start
    const AuthStr = 'X-Token '.concat(this.props.location.state.requestID);
    const authAxios = axios.create({
      baseURL: axios.defaults.baseURL,
      headers: {
        'Authorization': AuthStr
      },
    });
    // Authentication using Auth Code - AON End
    const URL = '/PayeePortal/GetCountry';
    authAxios.get(URL)
      .then(response => {
        if (response.data.mainCoreRes != undefined && response.data.mainCoreRes.userMessage == "Expired Token") {
          this.props.history.push('/Timeout');
        }
        else {
          this.setState({ countryList: response.data.lstCountry })
        }
      })
      .catch(error => {
        this.setState({ errorMsg: 'GetCountry: Some error occured, Please try again later.' })
        console.log(error + '-->' + this.state.errorMsg);
      })
  }

  GetCurrency = () => {
    // Authentication using Auth Code - AON Start
    const AuthStr = 'X-Token '.concat(this.props.location.state.requestID);
    const authAxios = axios.create({
      baseURL: axios.defaults.baseURL,
      headers: {
        'Authorization': AuthStr
      },
    });
    // Authentication using Auth Code - AON End
    const URL = '/PayeePortal/GetCurrency';
    authAxios.get(URL)
      .then(response => {
        if (response.data.mainCoreRes != undefined && response.data.mainCoreRes.userMessage == "Expired Token") {
          this.props.history.push('/Timeout');
        }
        else {
          this.setState({ currencyList: response.data.lstCurrency })
        }
      })
      .catch(error => {
        this.setState({ errorMsg: 'GetCurrency: Some error occured, Please try again later.' })
        console.log(error + '-->' + this.state.errorMsg);
      })
  }

  changeHandler = e => {
    this.setState({ [e.target.name]: e.target.value })
  }

  LinkPISessionToRequest = () => {
    // Authentication using Auth Code - AON Start
    const AuthStr = 'X-Token '.concat(this.props.location.state.requestID);
    const authAxios = axios.create({
      baseURL: axios.defaults.baseURL,
      headers: {
        'Authorization': AuthStr
      },
    });
    // Authentication using Auth Code - AON End
    const URL = '/PayeePortal/LinkPISessionToRequest?sessionID=' + this.state.manageAccounts.SessionId;
    authAxios.get(URL)
      .then(response => {
        if (response.data.mainCoreRes != undefined && response.data.mainCoreRes.userMessage == "Expired Token") {
          this.props.history.push('/Timeout');
        }
      })
      .catch(error => {
        this.setState({ errorMsg: 'LinkPISessionToRequest: Some error occured, Please try again later.' })
        console.log(error + '-->' + this.state.errorMsg);
      })
  }

  GotoDashboard = (msg) => {
    confirmAlert({
      title: msg,
      closeOnEscape: false,
      closeOnClickOutside: false,
      buttons: [
        {
          label: 'Go to Dashboard',
          onClick: () => this.props.history.push("/Dashboard",{
            requestID: this.state.requestID,
              payeeName: this.state.payeeName,
              entityName: this.state.entityName,
              clientID: this.state.clientID,
              payeeEmail: this.state.payeeEmail
          })
        }
      ]
    });
  };

  PISessionIssueAlert = () => {
    confirmAlert({
      title: 'Alert!',
      message: 'Something went wrong. Please try again after sometime. Sorry for inconvenience.',
      closeOnEscape: false,
      closeOnClickOutside: false,
      buttons: [
        {
          label: 'Go to Dashboard',
          onClick: () => this.props.history.push("/Dashboard")
        }
      ]
    });
  };



  PayeeInitiate = () => {
    debugger;
    // Authentication using Auth Code - AON Start
    const AuthStr = 'X-Token '.concat(this.props.location.state.requestID);
    const authAxios = axios.create({
      baseURL: axios.defaults.baseURL,
      headers: {
        'Authorization': AuthStr
      },
    });
    // Authentication using Auth Code - AON End
    const URL = '/PayeePortal/SmartAddPayeeInitiate?uploadDetailId=';
    authAxios.get(URL)
      .then(response => {
        debugger;
        if (response.data.mainCoreRes != undefined && response.data.mainCoreRes.userMessage == "Expired Token") {
          this.props.history.push('/Timeout');
        }
        else {
          this.setState({ IsPayeeintiate: true });
          this.setState({ manageAccounts: JSON.parse(response.data.responsebody) })
          this.setState({ ErrorCode: this.state.manageAccounts.ErrorCode });
          this.setState({ ErrorMessage: this.state.manageAccounts.ErrorMessage });
          this.setState({ sessionID: this.state.manageAccounts.SessionId });
          this.setState({ requestColumns: this.state.manageAccounts.requestColumns });
          //this.setState({ requestColumns: null });

          this.setState({ respayload: this.state.manageAccounts.requestColumns });
          this.setState({ loading: false });
        }
      })
      .catch(error => {
        this.setState({ errorMsg: 'PayeeInitiate: Some error occured, Please try again later.' })
        console.log(error + '-->' + this.state.errorMsg);
      })
  }

  Call_Post = () => {
    debugger;
    this.setState({ IsPayeeintiate: false });
    this.setState({ loading: true });
    var payload = this.getPayload();
    var uploadDetailId = '';

    // Authentication using Auth Code - AON Start
    const AuthStr = 'X-Token '.concat(this.props.location.state.requestID);
    const authAxios = axios.create({
      baseURL: axios.defaults.baseURL,
      headers: {
        'Authorization': AuthStr
      },
    });
    // Authentication using Auth Code - AON End

    const URL = 'PayeePortal/SmartAddPayee';
    const params = new URLSearchParams();
    params.append('payload', payload);
    params.append('uploadDetailId', uploadDetailId);
    params.append('clientID', this.props.location.state.entityID);
    authAxios({
      method: 'post',
      url: URL,
      data: params
    }).then(response => {
      debugger;
      if (response.data.mainCoreRes != undefined && response.data.mainCoreRes.userMessage == "Expired Token") {
        this.props.history.push('/Timeout');
      }
      else {
        if (response.data.responsebody != undefined) {
          this.setState({ manageAccounts: JSON.parse(response.data.responsebody) })
        }

        if (this.state.manageAccounts.ErrorCode == "0") {

          this.setState({ verifiedColumns: this.state.manageAccounts.verifiedColumns });
          this.setState({ requestColumns: this.state.manageAccounts.requestColumns });
          this.setState({ ErrorCode: this.state.manageAccounts.ErrorCode });
          this.setState({ ErrorMessage: this.state.manageAccounts.ErrorMessage });
          this.setState({ sessionID: this.state.manageAccounts.SessionId });

          this.setState({ ProvinceList: this.state.manageAccounts.ProvinceList });
          this.setState({ respayload: this.state.manageAccounts.requestColumns });


          this.LinkPISessionToRequest();
          this.nextStep();
          if (this.state.manageAccounts.ErrorMessage == "Session Complete") {
            this.setState({ step: 3 });
            this.setState({ headerTitle: "Additional Information" });
          }
          this.setState({ loading: false });

        }
        else {
          this.setState({ loading: false });
          var msgArr = this.state.manageAccounts.ErrorMessage.split("</br></br>");
          if (msgArr[0].includes("Payee already exists")) {
            confirmAlert({
              customUI: ({ onClose }) => {
                return (
                  <div style={{ backgroundColor: "#fff", padding: "10px", borderRadius: "4px", border: "1px solid #000" }}>
                    <div className="MsgAlertBox">
                      <div className="py-2" style={{ backgroundColor: "#0073ae", padding: "10px", margin: "-11px", fontSize: "20px" }}>
                        <p className="mb-0 text-white"><b>Payee Duplicate Alert</b></p>
                      </div>
                      <div>
                        <div style={{ backgroundColor: "#13859D", fontSize: "20px", padding: "10px", borderRadius: "4px", color: "#FFF" }} className="col-md-12">
                          Payee already exists.
                        </div>
                        <br />
                        <div class="card-header" id="headingTwo">
                          <h5 class="mb-0" style={{ float: "right" }}>
                            <button className="btn btn-success" style={{ pointer: "cursor" }} onClick={onClose}>Close</button>
                          </h5><br /><br />
                        </div>
                      </div>
                    </div>
                  </div>
                );
              }
            });
          }
          else {
            if (payload.indexOf("IBAN Number") > 0 && this.state.manageAccounts.ErrorMessage.replace(/\,/g, "</br>").replace(/\Please provide column value:/g, "").indexOf("national code and bank account numbers are too short") > 0) {
              confirmAlert({
                customUI: ({ onClose }) => {
                  return (
                    <div style={{ backgroundColor: "#fff", padding: "10px", borderRadius: "4px", border: "1px solid #000" }}>
                      <div className="MsgAlertBox">
                        <div className="py-2" style={{ backgroundColor: "#0073ae", padding: "10px", margin: "-11px", fontSize: "20px" }}>
                          <p className="mb-0 text-white"><b>Information Required</b></p>
                        </div>
                        <div>
                          <div style={{ backgroundColor: "#13859D", fontSize: "20px", padding: "10px", borderRadius: "4px", color: "#FFF" }} className="col-md-12">
                            The IBAN provided is not valid. Please update and retry. An IBAN is required based on the currency and country selected.
                          </div>
                          <br />
                          <div class="card-header" id="headingTwo">
                            <h5 class="mb-0" style={{ float: "right" }}>
                              <button className="btn btn-success" style={{ pointer: "cursor" }} onClick={onClose}>Done</button>
                            </h5>
                            <br />
                            <br />
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                }
              });
            } else {
              confirmAlert({
                customUI: ({ onClose }) => {
                  return (
                    <div style={{ backgroundColor: "#fff", padding: "10px", borderRadius: "4px", border: "1px solid #000" }}>
                      <div className="MsgAlertBox">
                        <div className="py-2" style={{ backgroundColor: "#0073ae", padding: "10px", margin: "-11px", fontSize: "20px" }}>
                          <p className="mb-0 text-white"><b>Information Required</b></p>
                        </div>
                        <div>
                          <div style={{ backgroundColor: "#7F919A", fontSize: "20px", padding: "10px", borderRadius: "4px", color: "#FFF", marginTop: "20px" }} className="col-md-12 bgSubway">
                            Required payee details are missing. Please fill in all mandatory fields to proceed.</div>
                          <br />
                          <div style={{ backgroundColor: "#13859D", whiteSpace: "pre-wrap", fontSize: "20px", padding: "10px", borderRadius: "4px", color: "#FFF" }} className="col-md-12">
                            {this.state.manageAccounts.ErrorMessage.replace(" , Please provide column value:", "").replace(/\Please provide column value:/g, "").replace(/\, /g, '\n')}
                          </div>
                          <br />
                          <div class="card-header" id="headingTwo">
                            <h5 class="mb-0" style={{ float: "right" }}>
                              <button className="btn btn-success" style={{ pointer: "cursor" }} onClick={onClose}>Done</button>
                            </h5>

                            <br />
                            <br />
                          </div>
                        </div>
                      </div>

                    </div>


                  );
                }
              });
            }
          }
        }

      }

    }).catch(error => {
      this.setState({ errorMsg: 'Call_Post: Some error occured, Please try again later.' })
      console.log(error + '-->' + this.state.errorMsg);
    })
  }

  Call_Verify_Post = () => {
    debugger;
    this.setState({ loading: true });
    var payload = this.getPayload();
    var uploadDetailId = '';

    // Authentication using Auth Code - AON Start
    const AuthStr = 'X-Token '.concat(this.props.location.state.requestID);
    const authAxios = axios.create({
      baseURL: axios.defaults.baseURL,
      headers: {
        'Authorization': AuthStr
      },
    });
    // Authentication using Auth Code - AON End

    const URL = 'PayeePortal/AddPayee';
    const params = new URLSearchParams();
    params.append('requestColumnsString', payload);
    params.append('requestID', this.state.requestID);

    authAxios({
      method: 'post',
      url: URL,
      data: params
    }).then(response => {
      if (response.data.mainCoreRes != undefined && response.data.mainCoreRes.userMessage == "Expired Token") {
        this.props.history.push('/Timeout');
      }
      else {
        this.setState({ loading: false });
        debugger;
        if (response.data.objPayee.coreRes.status == 1) {
          this.GotoDashboard(response.data.objPayee.coreRes.userMessage);
        } else {
          confirmAlert({
            customUI: ({ onClose }) => {
              return (
                <div style={{ backgroundColor: "#fff", padding: "10px", borderRadius: "4px", border: "1px solid #000" }}>
                  <div className="MsgAlertBox">
                    <div className="py-2" style={{ backgroundColor: "#0073ae", padding: "10px", margin: "-11px", fontSize: "20px" }}>
                      <p className="mb-0 text-white"><b>Notification</b></p>
                    </div>
                    <div>
                      <div style={{ backgroundColor: "#7F919A", fontSize: "20px", padding: "10px", borderRadius: "4px", color: "#FFF", marginTop: "20px" }} className="col-md-12 bgSubway">
                        {response.data.objPayee.coreRes.userMessage}
                      </div>
                      <br />
                      <div style={{ backgroundColor: "#13859D", fontSize: "20px", padding: "10px", borderRadius: "4px", color: "#FFF" }} className="col-md-12">
                        {this.state.manageAccounts.ErrorMessage.replace(/\,/g, ",").replace(/\Please provide column value:/g, "")}
                      </div>
                      <br />
                      <div class="card-header" id="headingTwo">
                        <h5 class="mb-0" style={{ float: "right" }}>
                          <button className="btn btn-success" style={{ pointer: "cursor" }} onClick={onClose}>Done</button>
                        </h5>

                        <br />
                        <br />
                      </div>
                    </div>
                  </div>
                </div>
              );
            }
          });
        }
      }

    }).catch(error => {
      this.setState({ errorMsg: 'Call_Verify_Post: Some error occured, Please try again later.' })
      console.log(error + '-->' + this.state.errorMsg);
    })
  }

  submitAccount = e => {
    e.preventDefault()
    // console.log(this.state)
    debugger;
    if (this.state.step == 3) {
      this.Call_Verify_Post()
    }
    else {
      this.Call_Post()
    }

  }

  DeletePayeeObjectFirstLevel = () => {
    // Authentication using Auth Code - AON Start
    const AuthStr = 'X-Token '.concat(this.props.location.state.requestID);
    const authAxios = axios.create({
      baseURL: axios.defaults.baseURL,
      headers: {
        'Authorization': AuthStr
      },
    });
    // Authentication using Auth Code - AON End
    const URL = '/PayeePortal/DeletePayeeObjectFirstLevel?objRequest=';
    const pLoad = JSON.stringify(this.state.payload);
    authAxios.post(URL, { pLoad })
      .then(response => {

        if (response.data.mainCoreRes != undefined && response.data.mainCoreRes.userMessage == "Expired Token") {
          this.props.history.push('/Timeout');
        }
        else {
          var response = JSON.parse(response.Data.responsebody);
          if (response.ErrorCode == "0") {

            this.Call_Post();
          }
        }
      })
      .catch(error => {
        this.setState({ errorMsg: 'DeletePayeeObjectFirstLevel: Some error occured, Please try again later.' })
        console.log(error + '-->' + this.state.errorMsg);
      })
  }

  AutoSelectCurrency = (event) => {
    debugger;
    this.setState({ countryCode: event.target.value });
    // Authentication using Auth Code - AON Start
    const AuthStr = 'X-Token '.concat(this.props.location.state.requestID);
    const authAxios = axios.create({
      baseURL: axios.defaults.baseURL,
      headers: {
        'Authorization': AuthStr
      },
    });
    // Authentication using Auth Code - AON End
    const URL = '/PayeePortal/UpdatePayeeRequest?countryCode=' + event.target.value + '&wireID=0';
    authAxios.get(URL)
      .then(response => {
        if (response.data.mainCoreRes != undefined && response.data.mainCoreRes.userMessage == "Expired Token") {
          this.props.history.push('/Timeout');
        }              
      })
      .catch(error => {
        this.setState({ errorMsg: 'AutoSelectCurrency: Some error occured, Please try again later.' })
        console.log(error + '-->' + this.state.errorMsg);
      })
  }

  Bind_ProvinceList = (event) => {
     // Authentication using Auth Code - AON Start
     const AuthStr = 'X-Token '.concat(this.props.location.state.requestID);
     const authAxios = axios.create({
       baseURL: axios.defaults.baseURL,
       headers: {
         'Authorization': AuthStr
       },
     });
     // Authentication using Auth Code - AON End
    const URL = '/PayeePortal/GetCountryBaseProvince?CountryCode=' + event.target.value;
    authAxios.get(URL)
      .then(response => {
        if (response.data.mainCoreRes != undefined && response.data.mainCoreRes.userMessage == "Expired Token") {
          this.props.history.push('/Timeout');
        }
        else {
        if (response.data.objProvinceListResponse.getProvinceList != null && response.data.objProvinceListResponse.getProvinceList.ProvinceList.length > 0) {
          this.setState({ ProvinceList: response.data.objProvinceListResponse.getProvinceList.ProvinceList });
          $("#txt_BeneficiaryProvince").attr("display", "none");
          var proCol = '<label style="padding-left: 0px;">Payee Province/State (Optional)</label> <select class="form-control loop-elment" id="txt_BeneficiaryProvince" title="Payee Province/State" ><option value="">[---Select---]</option>';

          $.each(response.data.objProvinceListResponse.getProvinceList.ProvinceList, function (j, TbProvinceRow) {
            debugger;
            if (TbProvinceRow.value == $("#txt_BeneficiaryProvince").val()) {
              proCol += '<option selected="selected" value="' + TbProvinceRow.ProvinceID + '">' + TbProvinceRow.Province + '</option>';
            } else {
              proCol += '<option value="' + TbProvinceRow.ProvinceID + '">' + TbProvinceRow.Province + '</option>';
            }
          });
          proCol += '</select>';
          $(".clsProvince").html(proCol);
        } else {
          var proCol = '<label style="padding-left: 0px;">Payee Province/State (Optional)</label><input type="text" id="txt_BeneficiaryProvince" title="Payee Province/State" value="" placeholder="" class = "form-control loop-elment"  maxlength="35"/">';
          $(".clsProvince").html(proCol);
        }
        }
      })
      .catch(error => {
        this.setState({ errorMsg: 'Bind_ProvinceList: Some error occured, Please try again later.' })
        console.log(error + '-->' + this.state.errorMsg);
      })
  }

  DynamicTabs = () => {
    if (this.state.step === 1) {
      //this.setState({headerTitle:"Name & Account Number"});
      let table = []
      table.push(<a class="nav-link active" id="v-pills-home-tab" data-toggle="pill" role="tab" aria-controls="v-pills-home" aria-selected="true">1. Name, Country & Currency</a>)
      table.push(<a class="nav-link">2. Bank Account Number / Your Address</a>)
      table.push(<a class="nav-link">3. Bank Address & Other Info.</a>)
      return table;
    }
    else if (this.state.step === 2) {
      // this.setState({headerTitle:"Bank Information"});
      let table = []
      table.push(<a class="nav-link">1. Name, Country & Currency</a>)
      table.push(<a class="nav-link active" id="v-pills-profile-tab" data-toggle="pill" role="tab" aria-controls="v-pills-profile" aria-selected="true">2. Bank Account Number / Your Address</a>)
      table.push(<a class="nav-link">3. Bank Address & Other Info.</a>)
      return table;
    }
    else if (this.state.step === 3) {
      // this.setState({headerTitle:"Additional Information"});
      let table = []
      table.push(<a class="nav-link">1. Name, Country & Currency</a>)
      table.push(<a class="nav-link">2. Bank Account Number / Your Address</a>)
      table.push(<a class="nav-link active" id="v-pills-messages-tab" data-toggle="pill" role="tab" aria-controls="v-pills-messages" aria-selected="true">3. Bank Address & Other Info.</a>)
      return table;
    }
  }

  ShowButtonsDynamic = () => {

    if (this.state.step === 1) {
      let table = []
      table.push(<button type="submit" className="btn btn-primary" style={{ float: "right", cursor: "pointer" }}> Next </button>)
      return table;
    }
    else if (this.state.step === 2) {
      let table = []
      table.push(<button type="submit" className="btn btn-primary" style={{ float: "right", cursor: "pointer" }}> Next </button>)
      // table.push(<button type="submit" className="btn btn-primary" style={{ float: "right",marginRight:"10px",cursor:"pointer" }} onClick={this.prevStep}> Previous </button>)     
      return table;
    }
    else {

      let table = []
      if (this.state.IsApprovalModel == "True" && this.state.IsUserAllowdToApprove == "True" && this.state.RemainingApproveCount > 1) {
        table.push(<button type="submit" className="btn btn-primary" style={{ float: "right", cursor: "pointer" }} > Submit for Approval </button>)
        //Call_Verify_Post
      }
      else if (this.state.IsUserAllowdToApprove == "False" && this.state.IsApprovalModel == "False") {
        table.push(<button type="submit" className="btn btn-warning" style={{ float: "right", cursor: "pointer" }} > Not Allowed to Submit </button>)
      }
      else {
        table.push(<button type="submit" className="btn btn-primary" style={{ float: "right", cursor: "pointer" }} > Finish </button>)
        //Call_Post
      }

      return table;
    }
  }

  AllowOnlyAlphanumeric = (e) => {
    // e.preventDefault();
  }

  AllowOnlyNumeric = (e) => {
    //  e.preventDefault();
  }

  CreateTableDynamicBankInformation = () => {

    let table = []
    let children = []
    //#region Bank Account Number / Your Address  
    if (this.state.ErrorMessage != "Session Complete") {

      if (this.state.requestColumns.length > 0) {

        for (let i = 0; i < this.state.requestColumns.length; i++) {
          var maxlengthnum = parseInt(this.state.requestColumns[i].SampleValue.replace(',', '').replace(/[^0-9]/gi, '')) || 35;
          var valRequired = this.state.requestColumns[i].ValueRequired == true ? '*' : '(Optional)';
          if (valRequired == "*") {

            if (this.state.requestColumns[i].ColumnID == "BeneficiaryAddress1") {
              children.push(<div className="col-md-12 m-t-20">
                <label>{this.state.requestColumns[i].ColumnName}
                  {valRequired}
                </label>
                <div id="the-basics">
                  <input
                    id={'txt_' + this.state.requestColumns[i].ColumnID}
                    name={this.state.requestColumns[i].ColumnID}
                    placeholder={this.state.requestColumns[i].SampleValue.replace(',', '')}
                    type="text"
                    className="form-control loop-elment"
                    title={this.state.requestColumns[i].ColumnName}
                    maxlength="35"
                    value={this.state.requestColumns[i].Value.replace(',', '')}

                  />
                </div>
              </div>)
            } else if (this.state.requestColumns[i].ColumnID == "BeneficiaryBankAddress2") {
              children.push(<div className="m-t-20">
                <label>{this.state.requestColumns[i].ColumnName}
                  {valRequired}
                </label>
                <div id="the-basics">
                  <input
                    id={'txt_' + this.state.requestColumns[i].ColumnID}
                    name={this.state.requestColumns[i].ColumnID}
                    placeholder={this.state.requestColumns[i].SampleValue.replace(',', '')}
                    type="text"
                    className="form-control loop-elment"
                    title={this.state.requestColumns[i].ColumnName}
                    maxlength="35"
                    value={this.state.requestColumns[i].Value.replace(',', '')}

                  />
                </div>
              </div>)
            } else if (this.state.requestColumns[i].ColumnID == "BeneficiaryCity") {
              children.push(<div className="col-md-4 m-t-20">
                <label>{this.state.requestColumns[i].ColumnName} {valRequired} </label>
                <div id="the-basics">
                  <input
                    id={'txt_' + this.state.requestColumns[i].ColumnID}
                    name={this.state.requestColumns[i].ColumnID}
                    placeholder={this.state.requestColumns[i].SampleValue.replace(',', '')}
                    type="text"
                    className="form-control loop-elment"
                    title={this.state.requestColumns[i].ColumnName}
                    maxlength="35"
                    value={this.state.requestColumns[i].Value.replace(',', '')}

                  />
                </div>
              </div>)
            } else if (this.state.requestColumns[i].ColumnID == "BeneficiaryProvince") {
              if (this.state.ProvinceList.length > 0) {
                children.push(<div className="col-md-4 m-t-20 clsProvince">
                  <label>{this.state.requestColumns[i].ColumnName} {valRequired} </label>
                  <div id="the-basics">
                    <select className="form-control loop-elment" id={'txt_' + this.state.requestColumns[i].ColumnID} title={this.state.requestColumns[i].ColumnName} >
                      <option value="">[---- Select ----]</option>
                      {this.state.ProvinceList.map((curr, ckey) =>
                        <option ckey={curr.value} value={curr.value}>{curr.text}</option>
                      )}
                    </select>
                  </div>
                </div>)
              }
              else {
                children.push(<div className="col-md-4 m-t-20">
                  <label>{this.state.requestColumns[i].ColumnName} {valRequired} </label>
                  <div id="the-basics clsProvince">
                    <input
                      id={'txt_' + this.state.requestColumns[i].ColumnID}
                      name={this.state.requestColumns[i].ColumnID}
                      placeholder={this.state.requestColumns[i].SampleValue.replace(',', '')}
                      type="text"
                      className="form-control loop-elment"
                      title={this.state.requestColumns[i].ColumnName}
                      maxlength="35"
                      value={this.state.requestColumns[i].Value.replace(',', '')}
                    />
                  </div>
                </div>)
              }
            } else if (this.state.requestColumns[i].ColumnID == "PostalCode") {
              children.push(<div className="col-md-4 m-t-20">
                <label>{this.state.requestColumns[i].ColumnName} {valRequired} </label>
                <div id="the-basics">
                  <input
                    id={'txt_' + this.state.requestColumns[i].ColumnID}
                    name={this.state.requestColumns[i].ColumnID}
                    placeholder={this.state.requestColumns[i].SampleValue.replace(',', '')}
                    type="text"
                    className="form-control loop-elment"
                    title={this.state.requestColumns[i].ColumnName}
                    maxlength="35"
                    value={this.state.requestColumns[i].Value.replace(',', '')}

                  />
                </div>
              </div>)
            } else if (this.state.requestColumns[i].ColumnName == "Swift Code") {
              // $('#txtRoutingType').val('1');
              children.push(<div className="col-md-4 m-t-20">
                <input type="hidden" id="RoutingType" name="RoutingType" value="1"></input>
                <label onClick={this.HideAdvSearch}>{this.state.requestColumns[i].ColumnName} {valRequired}
                  &nbsp;<span className="MainNavText label label-warning" id="MainNavHelp" style={{ backgroundColor: "#f8d408", color: "black", cursor: "pointer", padding: "0.2em 1.6em 0.3em", fontSize: "80%" }} >Lookup</span>
                </label>
                <div id="the-basics">
                  <input
                    id={'txt_' + this.state.requestColumns[i].ColumnID}
                    name={this.state.requestColumns[i].ColumnID}
                    placeholder={this.state.requestColumns[i].SampleValue.replace(',', '')}
                    type="text"
                    className="form-control loop-elment"
                    title={this.state.requestColumns[i].ColumnName}
                    maxlength={maxlengthnum}
                    value={this.state.requestColumns[i].Value.replace(',', '')}
                    onKeyPress={this.AllowOnlyAlphanumeric}
                  />
                </div>
              </div>)
            } else if (this.state.requestColumns[i].ColumnID == "BankCode") {
              // $('#txtRoutingType').val('1');
              children.push(<div className="col-md-4 m-t-20">
                <input type="hidden" id="RoutingType" name="RoutingType" value="1"></input>
                <label>{this.state.requestColumns[i].ColumnName} {valRequired} </label>
                <div id="the-basics">
                  <input
                    id={'txt_' + this.state.requestColumns[i].ColumnID}
                    name={this.state.requestColumns[i].ColumnID}
                    placeholder={this.state.requestColumns[i].SampleValue.replace(',', '')}
                    type="text"
                    className="form-control loop-elment"
                    title={this.state.requestColumns[i].ColumnName}
                    maxlength={maxlengthnum}
                    value={this.state.requestColumns[i].Value.replace(',', '')}
                    onKeyPress={this.AllowOnlyAlphanumeric}
                  />
                </div>
              </div>)
            } else if (this.state.requestColumns[i].ColumnName == "ABA") {
              //    $('#txtRoutingType').val('10');
              children.push(<div className="col-md-4 m-t-20">
                <input type="hidden" id="RoutingType" name="RoutingType" value="10"></input>
                <label onClick={this.HideAdvSearch}>{this.state.requestColumns[i].ColumnName} {valRequired}
                  &nbsp;<span className="MainNavText label label-warning" id="MainNavHelp" style={{ backgroundColor: "#f8d408", color: "black", cursor: "pointer", padding: "0.2em 1.6em 0.3em", fontSize: "80%" }} >Lookup</span>
                </label>
                <div id="the-basics">
                  <input
                    id={'txt_' + this.state.requestColumns[i].ColumnID}
                    name={this.state.requestColumns[i].ColumnID}
                    placeholder={this.state.requestColumns[i].SampleValue.replace(',', '')}
                    type="text"
                    className="form-control loop-elment"
                    title={this.state.requestColumns[i].ColumnName}
                    maxlength={maxlengthnum}
                    value={this.state.requestColumns[i].Value.replace(',', '')}
                    onKeyPress={this.AllowOnlyAlphanumeric}
                  />
                </div>
              </div>)
            } else if (this.state.requestColumns[i].ColumnID == "ReasonForPayment") {
              //    $('#txtRoutingType').val('10');
              children.push(<div className="col-md-4 m-t-20">
                <input type="hidden" id="RoutingType" name="RoutingType" value="10"></input>
                <label>Reference Information/Purpose of Payment' {valRequired} </label>
                <div id="the-basics">
                  <input
                    id={'txt_' + this.state.requestColumns[i].ColumnID}
                    name={this.state.requestColumns[i].ColumnID}
                    placeholder={this.state.requestColumns[i].SampleValue.replace(',', '')}
                    type="text"
                    className="form-control loop-elment"
                    title={this.state.requestColumns[i].ColumnName}
                    maxlength={maxlengthnum}
                    value={this.state.requestColumns[i].Value.replace(',', '')}
                    onKeyPress={this.AllowOnlyAlphanumeric}
                  />
                </div>
              </div>)
            } else {

              if (this.state.requestColumns[i].ColumnName == "TRANSIT") {
                //$('#txtRoutingType').val('9');
                if (this.state.requestColumns[i].SampleValue.slice(this.state.requestColumns[i].SampleValue.indexOf(";") + 1) == "Numeric") {
                  children.push(<div className="col-md-4 m-t-20">
                    <input type="hidden" id="RoutingType" name="RoutingType" value="9"></input>
                    <label onClick={this.HideAdvSearch}>Transit Code {valRequired}
                      &nbsp;<span className="MainNavText label label-warning" id="MainNavHelp" style={{ backgroundColor: "#f8d408", color: "black", cursor: "pointer", padding: "0.2em 1.6em 0.3em", fontSize: "80%" }} >Lookup</span>
                    </label>
                    <div id="the-basics">
                      <input
                        id={'txt_' + this.state.requestColumns[i].ColumnID}
                        name={this.state.requestColumns[i].ColumnID}
                        placeholder={this.state.requestColumns[i].SampleValue.replace(',', '')}
                        type="text"
                        className="form-control loop-elment"
                        title="Transit Code"
                        maxlength={maxlengthnum}
                        value={this.state.requestColumns[i].Value.replace(',', '')}
                        onKeyPress={this.AllowOnlyNumeric}
                      />
                    </div>
                  </div>)
                } else {
                  children.push(<div className="col-md-4 m-t-20">
                    <label onClick={this.HideAdvSearch}>Transit Code {valRequired}
                      &nbsp;<span className="MainNavText label label-warning" id="MainNavHelp" style={{ backgroundColor: "#f8d408", color: "black", cursor: "pointer", padding: "0.2em 1.6em 0.3em", fontSize: "80%" }} >Lookup</span>
                    </label>
                    <div id="the-basics">
                      <input
                        id={'txt_' + this.state.requestColumns[i].ColumnID}
                        name={this.state.requestColumns[i].ColumnID}
                        placeholder={this.state.requestColumns[i].SampleValue.replace(',', '')}
                        type="text"
                        className="form-control loop-elment"
                        title="Transit Code"
                        maxlength={maxlengthnum}
                        value={this.state.requestColumns[i].Value.replace(',', '')}
                        onKeyPress={this.AllowOnlyAlphanumeric}
                      />
                    </div>
                  </div>)
                }

              } else {
                if (this.state.requestColumns[i].SampleValue.slice(this.state.requestColumns[i].SampleValue.indexOf(";") + 1) == "Numeric") {
                  children.push(<div className="col-md-4 m-t-20">
                    <label>{this.state.requestColumns[i].ColumnName} {valRequired} </label>
                    <div id="the-basics">
                      <input
                        id={'txt_' + this.state.requestColumns[i].ColumnID}
                        name={this.state.requestColumns[i].ColumnID}
                        placeholder={this.state.requestColumns[i].SampleValue.replace(',', '')}
                        type="text"
                        className="form-control loop-elment"
                        title={this.state.requestColumns[i].ColumnName}
                        maxlength={maxlengthnum}
                        value={this.state.requestColumns[i].Value.replace(',', '')}
                        onKeyPress={this.AllowOnlyNumeric}
                      />
                    </div>
                  </div>)
                } else {
                  children.push(<div className="col-md-4 m-t-20">
                    <label>{this.state.requestColumns[i].ColumnName} {valRequired}</label>
                    <div id="the-basics">
                      <input
                        id={'txt_' + this.state.requestColumns[i].ColumnID}
                        name={this.state.requestColumns[i].ColumnID}
                        placeholder={this.state.requestColumns[i].SampleValue.replace(',', '')}
                        type="text"
                        className="form-control loop-elment"
                        title={this.state.requestColumns[i].ColumnName}
                        maxlength={maxlengthnum}
                        value={this.state.requestColumns[i].Value.replace(',', '')}
                        onKeyPress={this.AllowOnlyAlphanumeric}
                      />
                    </div>
                  </div>)
                }
              }

            }

          }
        }
      }
    }
    table.push(<div className="row">{children}</div>)

    return table;
    //#endregion
  }

  CreateTableDynamicYourAddress = () => {
    let table = []
    let children = []
    //#region Bank Account Number / Your Address  
    if (this.state.ErrorMessage != "Session Complete") {

      if (this.state.requestColumns.length > 0) {

        for (let i = 0; i < this.state.requestColumns.length; i++) {
          var maxlengthnum = parseInt(this.state.requestColumns[i].SampleValue.replace(',', '').replace(/[^0-9]/gi, '')) || 35;
          var valRequired = this.state.requestColumns[i].ValueRequired == true ? '*' : '(Optional)';
          if (valRequired == "(Optional)") {


            if (this.state.requestColumns[i].ColumnID == "BeneficiaryAddress1") {
              children.push(<div className="col-md-4 m-t-20">
                <label>{this.state.requestColumns[i].ColumnName}
                  {valRequired}
                </label>
                <div id="the-basics">
                  <input
                    id={'txt_' + this.state.requestColumns[i].ColumnID}
                    name={this.state.requestColumns[i].ColumnID}
                    placeholder={this.state.requestColumns[i].SampleValue.replace(',', '')}
                    type="text"
                    className="form-control loop-elment"
                    title={this.state.requestColumns[i].ColumnName}
                    maxlength="35"
                    value={this.state.requestColumns[i].Value.replace(',', '')}

                  />
                </div>
              </div>)
            } else if (this.state.requestColumns[i].ColumnID == "BeneficiaryBankAddress2") {
              children.push(<div className="col-md-4 m-t-20">
                <label>{this.state.requestColumns[i].ColumnName}
                  {valRequired}
                </label>
                <div id="the-basics">
                  <input
                    id={'txt_' + this.state.requestColumns[i].ColumnID}
                    name={this.state.requestColumns[i].ColumnID}
                    placeholder={this.state.requestColumns[i].SampleValue.replace(',', '')}
                    type="text"
                    className="form-control loop-elment"
                    title={this.state.requestColumns[i].ColumnName}
                    maxlength="35"
                    value={this.state.requestColumns[i].Value.replace(',', '')}

                  />
                </div>
              </div>)
            } else if (this.state.requestColumns[i].ColumnID == "BeneficiaryCity") {
              children.push(<div className="col-md-4 m-t-20">
                <label>{this.state.requestColumns[i].ColumnName} {valRequired} </label>
                <div id="the-basics">
                  <input
                    id={'txt_' + this.state.requestColumns[i].ColumnID}
                    name={this.state.requestColumns[i].ColumnID}
                    placeholder={this.state.requestColumns[i].SampleValue.replace(',', '')}
                    type="text"
                    className="form-control loop-elment"
                    title={this.state.requestColumns[i].ColumnName}
                    maxlength="35"
                    value={this.state.requestColumns[i].Value.replace(',', '')}

                  />
                </div>
              </div>)
            } else if (this.state.requestColumns[i].ColumnID == "BeneficiaryProvince") {
              if (this.state.ProvinceList.length > 0) {
                children.push(<div className="col-md-4 m-t-20 clsProvince">
                  <label>{this.state.requestColumns[i].ColumnName} {valRequired} </label>
                  <div id="the-basics">
                    <select className="form-control loop-elment" id={'txt_' + this.state.requestColumns[i].ColumnID} title={this.state.requestColumns[i].ColumnName} >
                      <option value="">[---- Select ----]</option>
                      {this.state.ProvinceList.map((curr, ckey) =>
                        <option ckey={curr.value} value={curr.value}>{curr.text}</option>
                      )}
                    </select>
                  </div>
                </div>)
              }
              else {
                children.push(<div className="col-md-4 m-t-20">
                  <label>{this.state.requestColumns[i].ColumnName} {valRequired} </label>
                  <div id="the-basics">
                    <input
                      id={'txt_' + this.state.requestColumns[i].ColumnID}
                      name={this.state.requestColumns[i].ColumnID}
                      placeholder={this.state.requestColumns[i].SampleValue.replace(',', '')}
                      type="text"
                      className="form-control loop-elment"
                      title={this.state.requestColumns[i].ColumnName}
                      maxlength="35"
                      value={this.state.requestColumns[i].Value.replace(',', '')}
                    />
                  </div>
                </div>)
              }
            } else if (this.state.requestColumns[i].ColumnID == "PostalCode") {
              children.push(<div className="col-md-4 m-t-20">
                <label>{this.state.requestColumns[i].ColumnName} {valRequired} </label>
                <div id="the-basics">
                  <input
                    id={'txt_' + this.state.requestColumns[i].ColumnID}
                    name={this.state.requestColumns[i].ColumnID}
                    placeholder={this.state.requestColumns[i].SampleValue.replace(',', '')}
                    type="text"
                    className="form-control loop-elment"
                    title={this.state.requestColumns[i].ColumnName}
                    maxlength="35"
                    value={this.state.requestColumns[i].Value.replace(',', '')}

                  />
                </div>
              </div>)
            } else if (this.state.requestColumns[i].ColumnName == "Swift Code") {
              // $('#txtRoutingType').val('1');
              children.push(<div className="col-md-4 m-t-20">
                <input type="hidden" id="RoutingType" name="RoutingType" value="1"></input>
                <label onClick={this.HideAdvSearch}>{this.state.requestColumns[i].ColumnName} {valRequired}
                  &nbsp;<span className="MainNavText label label-warning" id="MainNavHelp" style={{ backgroundColor: "#f8d408", color: "black", cursor: "pointer", padding: "0.2em 1.6em 0.3em", fontSize: "80%" }} >Lookup</span>
                </label>
                <div id="the-basics">
                  <input
                    id={'txt_' + this.state.requestColumns[i].ColumnID}
                    name={this.state.requestColumns[i].ColumnID}
                    placeholder={this.state.requestColumns[i].SampleValue.replace(',', '')}
                    type="text"
                    className="form-control loop-elment"
                    title={this.state.requestColumns[i].ColumnName}
                    maxlength={maxlengthnum}
                    value={this.state.requestColumns[i].Value.replace(',', '')}
                    onKeyPress={this.AllowOnlyAlphanumeric}
                  />
                </div>
              </div>)
            } else if (this.state.requestColumns[i].ColumnID == "BankCode") {
              // $('#txtRoutingType').val('1');
              children.push(<div className="col-md-4 m-t-20">
                <input type="hidden" id="RoutingType" name="RoutingType" value="1"></input>
                <label>{this.state.requestColumns[i].ColumnName} {valRequired} </label>
                <div id="the-basics">
                  <input
                    id={'txt_' + this.state.requestColumns[i].ColumnID}
                    name={this.state.requestColumns[i].ColumnID}
                    placeholder={this.state.requestColumns[i].SampleValue.replace(',', '')}
                    type="text"
                    className="form-control loop-elment"
                    title={this.state.requestColumns[i].ColumnName}
                    maxlength={maxlengthnum}
                    value={this.state.requestColumns[i].Value.replace(',', '')}
                    onKeyPress={this.AllowOnlyAlphanumeric}
                  />
                </div>
              </div>)
            } else if (this.state.requestColumns[i].ColumnName == "ABA") {
              //    $('#txtRoutingType').val('10');
              children.push(<div className="col-md-4 m-t-20">
                <input type="hidden" id="RoutingType" name="RoutingType" value="10"></input>
                <label onClick={this.HideAdvSearch}>{this.state.requestColumns[i].ColumnName} {valRequired}
                  &nbsp;<span className="MainNavText label label-warning" id="MainNavHelp" style={{ backgroundColor: "#f8d408", color: "black", cursor: "pointer", padding: "0.2em 1.6em 0.3em", fontSize: "80%" }} >Lookup</span>
                </label>
                <div id="the-basics">
                  <input
                    id={'txt_' + this.state.requestColumns[i].ColumnID}
                    name={this.state.requestColumns[i].ColumnID}
                    placeholder={this.state.requestColumns[i].SampleValue.replace(',', '')}
                    type="text"
                    className="form-control loop-elment"
                    title={this.state.requestColumns[i].ColumnName}
                    maxlength={maxlengthnum}
                    value={this.state.requestColumns[i].Value.replace(',', '')}
                    onKeyPress={this.AllowOnlyAlphanumeric}
                  />
                </div>
              </div>)
            } else if (this.state.requestColumns[i].ColumnID == "ReasonForPayment") {
              children.push(<div className="col-md-4 m-t-20">
                <label>Reference Information/Purpose of Payment' {valRequired} </label>
                <div id="the-basics">
                  <input
                    id={'txt_' + this.state.requestColumns[i].ColumnID}
                    name={this.state.requestColumns[i].ColumnID}
                    placeholder={this.state.requestColumns[i].SampleValue.replace(',', '')}
                    type="text"
                    className="form-control loop-elment"
                    title={this.state.requestColumns[i].ColumnName}
                    maxlength={maxlengthnum}
                    value={this.state.requestColumns[i].Value.replace(',', '')}
                    onKeyPress={this.AllowOnlyAlphanumeric}
                  />
                </div>
              </div>)
            } else {

              if (this.state.requestColumns[i].ColumnName == "TRANSIT") {
                //$('#txtRoutingType').val('9');
                if (this.state.requestColumns[i].SampleValue.slice(this.state.requestColumns[i].SampleValue.indexOf(";") + 1) == "Numeric") {
                  children.push(<div className="col-md-4 m-t-20">
                    <input type="hidden" id="RoutingType" name="RoutingType" value="9"></input>
                    <label onClick={this.HideAdvSearch}>Transit Code {valRequired}
                      &nbsp;<span className="MainNavText label label-warning" id="MainNavHelp" style={{ backgroundColor: "#f8d408", color: "black", cursor: "pointer", padding: "0.2em 1.6em 0.3em", fontSize: "80%" }} >Lookup</span>
                    </label>
                    <div id="the-basics">
                      <input
                        id={'txt_' + this.state.requestColumns[i].ColumnID}
                        name={this.state.requestColumns[i].ColumnID}
                        placeholder={this.state.requestColumns[i].SampleValue.replace(',', '')}
                        type="text"
                        className="form-control loop-elment"
                        title="Transit Code"
                        maxlength={maxlengthnum}
                        value={this.state.requestColumns[i].Value.replace(',', '')}
                        onKeyPress={this.AllowOnlyNumeric}
                      />
                    </div>
                  </div>)
                } else {
                  children.push(<div className="col-md-4 m-t-20">
                    <label onClick={this.HideAdvSearch}>Transit Code {valRequired}
                      &nbsp;<span className="MainNavText label label-warning" id="MainNavHelp" style={{ backgroundColor: "#f8d408", color: "black", cursor: "pointer", padding: "0.2em 1.6em 0.3em", fontSize: "80%" }} >Lookup</span>
                    </label>
                    <div id="the-basics">
                      <input
                        id={'txt_' + this.state.requestColumns[i].ColumnID}
                        name={this.state.requestColumns[i].ColumnID}
                        placeholder={this.state.requestColumns[i].SampleValue.replace(',', '')}
                        type="text"
                        className="form-control loop-elment"
                        title="Transit Code"
                        maxlength={maxlengthnum}
                        value={this.state.requestColumns[i].Value.replace(',', '')}
                        onKeyPress={this.AllowOnlyAlphanumeric}
                      />
                    </div>
                  </div>)
                }

              } else {
                if (this.state.requestColumns[i].SampleValue.slice(this.state.requestColumns[i].SampleValue.indexOf(";") + 1) == "Numeric") {
                  children.push(<div className="col-md-4 m-t-20">
                    <label>{this.state.requestColumns[i].ColumnName} {valRequired} </label>
                    <div id="the-basics">
                      <input
                        id={'txt_' + this.state.requestColumns[i].ColumnID}
                        name={this.state.requestColumns[i].ColumnID}
                        placeholder={this.state.requestColumns[i].SampleValue.replace(',', '')}
                        type="text"
                        className="form-control loop-elment"
                        title={this.state.requestColumns[i].ColumnName}
                        maxlength={maxlengthnum}
                        value={this.state.requestColumns[i].Value.replace(',', '')}
                        onKeyPress={this.AllowOnlyNumeric}
                      />
                    </div>
                  </div>)
                } else {
                  children.push(<div className="col-md-4 m-t-20">
                    <label>{this.state.requestColumns[i].ColumnName} {valRequired}</label>
                    <div id="the-basics">
                      <input
                        id={'txt_' + this.state.requestColumns[i].ColumnID}
                        name={this.state.requestColumns[i].ColumnID}
                        placeholder={this.state.requestColumns[i].SampleValue.replace(',', '')}
                        type="text"
                        className="form-control loop-elment"
                        title={this.state.requestColumns[i].ColumnName}
                        maxlength={maxlengthnum}
                        value={this.state.requestColumns[i].Value.replace(',', '')}
                        onKeyPress={this.AllowOnlyAlphanumeric}
                      />
                    </div>
                  </div>)
                }
              }

            }
          }
        }
      }
    }

    table.push(<div className="row">{children}</div>)
    return table;
    //#endregion
  }

  CreateTableDynamic = () => {
    debugger;
    let table = []
    let children = []
    //alert('1515');

    // Outer loop to create parent


    if (this.state.ErrorMessage != "Session Complete") {
      debugger;
      if (this.state.requestColumns != 'undefined' && this.state.requestColumns != null && this.state.requestColumns.length > 0) {
        if (this.state.requestColumns.length > 0) {

          for (let i = 0; i < this.state.requestColumns.length; i++) {
            var maxlengthnum = parseInt(this.state.requestColumns[i].SampleValue.replace(',', '').replace(/[^0-9]/gi, '')) || 35;
            var valRequired = this.state.requestColumns[i].ValueRequired == true ? '*' : '(Optional)';

            if (this.state.step == 1) {
              //#region Payee Initiate


              if (this.state.requestColumns[i].ColumnID == "PayeeName") {
                children.push(<div className="col-md-4 m-t-20">
                  <label>{this.state.requestColumns[i].ColumnName} {valRequired}</label>
                  <div id="the-basics" style={{ cursor: "not-allowed" }}>
                    <input
                      id={'txt_' + this.state.requestColumns[i].ColumnID}
                      name={this.state.requestColumns[i].ColumnID}
                      placeholder={this.state.requestColumns[i].SampleValue.replace(',', '')}
                      type="text"
                      className="form-control loop-elment"
                      title={this.state.requestColumns[i].ColumnName}
                      // value={this.state.requestColumns[i].Value.replace(',', '')}
                      value={this.state.payeeName}
                      maxlength="35"
                      disabled
                    />
                  </div>
                </div>)
              } else if (this.state.requestColumns[i].ColumnID == "PayeeNickName") {
                children.push(<div className="col-md-4 m-t-20" style={{ display: "none" }}>
                  <label>{this.state.requestColumns[i].ColumnName} {valRequired}</label>
                  <div id="the-basics" style={{ cursor: "not-allowed" }}>
                    <input
                      id={'txt_' + this.state.requestColumns[i].ColumnID}
                      name={this.state.requestColumns[i].ColumnID}
                      placeholder={this.state.requestColumns[i].SampleValue.replace(',', '')}
                      type="text"
                      className="form-control loop-elment"
                      title={this.state.requestColumns[i].ColumnName}
                      //defaultValue={this.state.requestColumns[i].Value.replace(',', '')}             
                      defaultValue={this.state.nickname}
                      maxlength="35"
                    />
                  </div>
                </div>)
              } else if (this.state.requestColumns[i].ColumnID == "PayeeType") {
                children.push(<div className="col-md-4 m-t-20">
                  <label>{this.state.requestColumns[i].ColumnName} {valRequired}</label>
                  <div id="bloodhound">
                    <select className="form-control loop-elment" id={'txt_' + this.state.requestColumns[i].ColumnID} name={this.state.requestColumns[i].ColumnID} title={this.state.requestColumns[i].ColumnName}>
                      <option value="Corporate">Corporate</option>
                      <option value="Individual">Individual</option>
                    </select>
                  </div>
                </div>)
              } else if (this.state.requestColumns[i].ColumnID == "CountryCode") {
                children.push(<div className="col-md-4 m-t-20">
                  <label htmlFor="country">{this.state.requestColumns[i].ColumnName} {valRequired}</label>

                  <select className="form-control loop-elment" id={'txt_' + this.state.requestColumns[i].ColumnID} title={this.state.requestColumns[i].ColumnName} onChange={this.AutoSelectCurrency}>
                    <option value="">[---- Select ----]</option>
                    {this.state.countryList.map((country, cckey) =>
                      country.value == this.state.requestColumns[i].Value.replace(',', '') ?
                        <option cckey={country.value} value={country.value} selected>{country.text}</option> :
                        <option cckey={country.value} value={country.value}>{country.text}</option>
                    )}
                  </select>
                </div>)
              } else if (this.state.requestColumns[i].ColumnID == "BeneficiaryCountryCode") {
                children.push(<div className="col-md-4 m-t-20">
                  <label htmlFor="country">{this.state.requestColumns[i].ColumnName} {valRequired}</label>
                  <select className="form-control loop-elment" id={'txt_' + this.state.requestColumns[i].ColumnID} title={this.state.requestColumns[i].ColumnName} onChange={this.Bind_ProvinceList}>
                    <option value="">[---- Select ----]</option>
                    {this.state.countryList.map((country, bcckey) =>
                      <option bcckey={country.value} value={country.value}>{country.text}</option>
                    )}
                  </select>
                </div>)
              } else if (this.state.requestColumns[i].ColumnID == "Currency") {
                children.push(<div className="col-md-4 m-t-20">
                  <label>{this.state.requestColumns[i].ColumnName} {valRequired}</label>
                  <div id="the-basics">
                    <select className="form-control loop-elment" id={'txt_' + this.state.requestColumns[i].ColumnID} title={this.state.requestColumns[i].ColumnName} disabled>
                      <option value="">[---- Select ----]</option>
                      {this.state.currencyList.map((curr, ckey) =>
                        //curr.value == this.state.requestColumns[i].Value.replace(',', '') ?
                        curr.value == this.state.currency ?
                          <option ckey={curr.value} value={curr.value} selected>{curr.text}</option> :
                          <option ckey={curr.value} value={curr.value}>{curr.text}</option>
                      )}
                    </select>
                  </div>
                </div>)
              } else if (this.state.requestColumns[i].ColumnID == "PayeeEmail") {
                children.push(<div className="col-md-4 m-t-20">
                  <label>{this.state.requestColumns[i].ColumnName} *
                    {/* {valRequired} */}
                  </label>
                  <div id="the-basics">
                    <input
                      id={'txt_' + this.state.requestColumns[i].ColumnID}
                      name={this.state.requestColumns[i].ColumnID}
                      placeholder={this.state.requestColumns[i].SampleValue.replace(',', '')}
                      type="text"
                      className="form-control loop-elment"
                      title={this.state.requestColumns[i].ColumnName}
                      maxlength="35"
                      //value={this.state.requestColumns[i].Value.replace(',', '')}
                      value={this.state.payeeEmail}
                      // onChange={this.handleChange}   
                      disabled
                    />
                  </div>
                </div>)
              }

              //#endregion
            }
            if (this.state.step == 2) {
              //#region Bank Account Number / Your Address  

              if (this.state.requestColumns[i].ColumnID == "BeneficiaryAddress1") {
                children.push(<div className="col-md-4 m-t-20">
                  <label>{this.state.requestColumns[i].ColumnName}
                    {valRequired}
                  </label>
                  <div id="the-basics">
                    <input
                      id={'txt_' + this.state.requestColumns[i].ColumnID}
                      name={this.state.requestColumns[i].ColumnID}
                      placeholder={this.state.requestColumns[i].SampleValue.replace(',', '')}
                      type="text"
                      className="form-control loop-elment"
                      title={this.state.requestColumns[i].ColumnName}
                      maxlength="35"
                      // value={this.state.value}
                      defaultValue={this.state.requestColumns[i].Value.replace(',', '')}
                      onChange={this.handleChange}
                    />
                  </div>
                </div>)
              } else if (this.state.requestColumns[i].ColumnID == "BeneficiaryBankAddress2") {
                // console.log(this.state.requestColumn);
                children.push(<div className="col-md-4 m-t-20">
                  <label>{this.state.requestColumns[i].ColumnName}
                    {valRequired}
                  </label>
                  <div id="the-basics">
                    <input
                      id={'txt_' + this.state.requestColumns[i].ColumnID}
                      name={this.state.requestColumns[i].ColumnID}
                      placeholder={this.state.requestColumns[i].SampleValue.replace(',', '')}
                      type="text"
                      className="form-control loop-elment"
                      title={this.state.requestColumns[i].ColumnName}
                      maxlength="35"
                      //value={this.state.value}                 

                      defaultValue={this.state.requestColumns[i].Value.replace(',', '')}
                      onChange={this.handleChange}
                    />
                  </div>
                </div>)
              } else if (this.state.requestColumns[i].ColumnID == "BeneficiaryCity") {
                children.push(<div className="col-md-4 m-t-20">
                  <label>{this.state.requestColumns[i].ColumnName} {valRequired} </label>
                  <div id="the-basics">
                    <input
                      id={'txt_' + this.state.requestColumns[i].ColumnID}
                      name={this.state.requestColumns[i].ColumnID}
                      placeholder={this.state.requestColumns[i].SampleValue.replace(',', '')}
                      type="text"
                      className="form-control loop-elment"
                      title={this.state.requestColumns[i].ColumnName}
                      maxlength="35"
                      // value={this.state.requestColumns[i].Value.replace(',', '')}
                      defaultValue={this.state.requestColumns[i].Value.replace(',', '')}
                      onChange={this.handleChange}
                    />
                  </div>
                </div>)
              } else if (this.state.requestColumns[i].ColumnID == "BeneficiaryCountryCode") {
                children.push(<div className="col-md-4 m-t-20">
                  <label htmlFor="country">{this.state.requestColumns[i].ColumnName} {valRequired}</label>
                  <select className="form-control loop-elment" id={'txt_' + this.state.requestColumns[i].ColumnID} title={this.state.requestColumns[i].ColumnName} onChange={this.Bind_ProvinceList}>
                    <option value="">[---- Select ----]</option>
                    {this.state.countryList.map((country, bcckey) =>
                      <option bcckey={country.value} value={country.value}>{country.text}</option>
                    )}
                  </select>
                </div>)
              } else if (this.state.requestColumns[i].ColumnID == "BeneficiaryProvince") {
                if (this.state.ProvinceList.length > 0) {
                  debugger;
                  children.push(<div className="col-md-4 m-t-20 clsProvince">
                    <label>{this.state.requestColumns[i].ColumnName} {valRequired} </label>
                    <div id="the-basics">
                      <select className="form-control loop-elment" id={'txt_' + this.state.requestColumns[i].ColumnID} title={this.state.requestColumns[i].ColumnName} >
                        <option value="">[---- Select ----]</option>
                        {this.state.ProvinceList.map((curr, ckey) =>
                          <option ckey={curr.ProvinceID} value={curr.ProvinceID}>{curr.Province}</option>
                        )}
                      </select>
                    </div>
                  </div>)
                }
                else {
                  children.push(<div className="col-md-4 m-t-20">
                    <label>{this.state.requestColumns[i].ColumnName} {valRequired} </label>
                    <div id="the-basics">
                      <input
                        id={'txt_' + this.state.requestColumns[i].ColumnID}
                        name={this.state.requestColumns[i].ColumnID}
                        placeholder={this.state.requestColumns[i].SampleValue.replace(',', '')}
                        type="text"
                        className="form-control loop-elment"
                        title={this.state.requestColumns[i].ColumnName}
                        maxlength="35"
                        // value={this.state.requestColumns[i].Value.replace(',', '')}
                        defaultValue={this.state.requestColumns[i].Value.replace(',', '')}
                        onChange={this.handleChange}
                      />
                    </div>
                  </div>)
                }
              } else if (this.state.requestColumns[i].ColumnID == "PostalCode") {
                children.push(<div className="col-md-4 m-t-20">
                  <label>{this.state.requestColumns[i].ColumnName} {valRequired} </label>
                  <div id="the-basics">
                    <input
                      id={'txt_' + this.state.requestColumns[i].ColumnID}
                      name={this.state.requestColumns[i].ColumnID}
                      placeholder={this.state.requestColumns[i].SampleValue.replace(',', '')}
                      type="text"
                      className="form-control loop-elment"
                      title={this.state.requestColumns[i].ColumnName}
                      maxlength="35"
                      // value={this.state.requestColumns[i].Value.replace(',', '')}
                      defaultValue={this.state.requestColumns[i].Value.replace(',', '')}
                      onChange={this.handleChange}
                    />
                  </div>
                </div>)
              } else if (this.state.requestColumns[i].ColumnName == "Swift Code") {
                // $('#txtRoutingType').val('1');
                children.push(<div className="col-md-4 m-t-20">
                  <input type="hidden" id="RoutingType" name="RoutingType" value="1"></input>
                  <label onClick={this.HideAdvSearch}>{this.state.requestColumns[i].ColumnName} {valRequired}
                    &nbsp;<span className="MainNavText label label-warning" id="MainNavHelp" style={{ backgroundColor: "#f8d408", color: "black", cursor: "pointer", padding: "0.2em 1.6em 0.3em", fontSize: "80%" }} >Lookup</span>
                  </label>
                  <div id="the-basics">
                    <input
                      id={'txt_' + this.state.requestColumns[i].ColumnID}
                      name={this.state.requestColumns[i].ColumnID}
                      placeholder={this.state.requestColumns[i].SampleValue.replace(',', '')}
                      type="text"
                      className="form-control loop-elment"
                      title={this.state.requestColumns[i].ColumnName}
                      maxlength={maxlengthnum}
                      // value={this.state.requestColumns[i].Value.replace(',', '')}
                      defaultValue={this.state.requestColumns[i].Value.replace(',', '')}
                      onChange={this.handleChange}
                      onKeyPress={this.AllowOnlyAlphanumeric}
                    />
                  </div>
                </div>)
              } else if (this.state.requestColumns[i].ColumnID == "BankCode") {
                // $('#txtRoutingType').val('1');
                children.push(<div className="col-md-4 m-t-20">
                  <input type="hidden" id="RoutingType" name="RoutingType" value="1"></input>
                  <label>{this.state.requestColumns[i].ColumnName} {valRequired} </label>
                  <div id="the-basics">
                    <input
                      id={'txt_' + this.state.requestColumns[i].ColumnID}
                      name={this.state.requestColumns[i].ColumnID}
                      placeholder={this.state.requestColumns[i].SampleValue.replace(',', '')}
                      type="text"
                      className="form-control loop-elment"
                      title={this.state.requestColumns[i].ColumnName}
                      maxlength={maxlengthnum}
                      // value={this.state.requestColumns[i].Value.replace(',', '')}
                      defaultValue={this.state.requestColumns[i].Value.replace(',', '')}
                      onChange={this.handleChange}
                      onKeyPress={this.AllowOnlyAlphanumeric}
                    />
                  </div>
                </div>)
              } else if (this.state.requestColumns[i].ColumnName == "ABA") {
                //    $('#txtRoutingType').val('10');
                children.push(<div className="col-md-4 m-t-20">
                  <input type="hidden" id="RoutingType" name="RoutingType" value="10"></input>
                  <label onClick={this.HideAdvSearch}>{this.state.requestColumns[i].ColumnName} {valRequired}
                    &nbsp;<span className="MainNavText label label-warning" id="MainNavHelp" style={{ backgroundColor: "#f8d408", color: "black", cursor: "pointer", padding: "0.2em 1.6em 0.3em", fontSize: "80%" }} >Lookup</span>
                  </label>
                  <div id="the-basics">
                    <input
                      id={'txt_' + this.state.requestColumns[i].ColumnID}
                      name={this.state.requestColumns[i].ColumnID}
                      placeholder={this.state.requestColumns[i].SampleValue.replace(',', '')}
                      type="text"
                      className="form-control loop-elment"
                      title={this.state.requestColumns[i].ColumnName}
                      maxlength={maxlengthnum}
                      //value={this.state.requestColumns[i].Value.replace(',', '')}
                      defaultValue={this.state.requestColumns[i].Value.replace(',', '')}
                      onChange={this.handleChange}
                      onKeyPress={this.AllowOnlyAlphanumeric}
                    />
                  </div>
                </div>)
              } else if (this.state.requestColumns[i].ColumnID == "ReasonForPayment") {
                children.push(<div className="col-md-4 m-t-20">
                  <label>Reference Information/Purpose of Payment' {valRequired} </label>
                  <div id="the-basics">
                    <input
                      id={'txt_' + this.state.requestColumns[i].ColumnID}
                      name={this.state.requestColumns[i].ColumnID}
                      placeholder={this.state.requestColumns[i].SampleValue.replace(',', '')}
                      type="text"
                      className="form-control loop-elment"
                      title={this.state.requestColumns[i].ColumnName}
                      maxlength={maxlengthnum}
                      //value={this.state.requestColumns[i].Value.replace(',', '')}
                      defaultValue={this.state.requestColumns[i].Value.replace(',', '')}
                      onChange={this.handleChange}
                      onKeyPress={this.AllowOnlyAlphanumeric}
                    />
                  </div>
                </div>)
              } else {
                if (this.state.requestColumns[i].ColumnName == "TRANSIT") {
                  //$('#txtRoutingType').val('9');
                  if (this.state.requestColumns[i].SampleValue.slice(this.state.requestColumns[i].SampleValue.indexOf(";") + 1) == "Numeric") {
                    children.push(<div className="col-md-4 m-t-20">
                      <input type="hidden" id="RoutingType" name="RoutingType" value="9"></input>
                      <label onClick={this.HideAdvSearch}>Transit Code {valRequired}
                        &nbsp;<span className="MainNavText label label-warning" id="MainNavHelp" style={{ backgroundColor: "#f8d408", color: "black", cursor: "pointer", padding: "0.2em 1.6em 0.3em", fontSize: "80%" }} >Lookup</span>
                      </label>
                      <div id="the-basics">
                        <input
                          id={'txt_' + this.state.requestColumns[i].ColumnID}
                          name={this.state.requestColumns[i].ColumnID}
                          placeholder={this.state.requestColumns[i].SampleValue.replace(',', '')}
                          type="text"
                          className="form-control loop-elment"
                          title="Transit Code"
                          maxlength={maxlengthnum}
                          //value={this.state.requestColumns[i].Value.replace(',', '')}
                          defaultValue={this.state.requestColumns[i].Value.replace(',', '')}
                          onChange={this.handleChange}
                          onKeyPress={this.AllowOnlyNumeric}
                        />
                      </div>
                    </div>)
                  } else {
                    children.push(<div className="col-md-4 m-t-20">
                      <input type="hidden" id="RoutingType" name="RoutingType" value="9"></input>
                      <label onClick={this.HideAdvSearch}>Transit Code {valRequired}
                        &nbsp;<span className="MainNavText label label-warning" id="MainNavHelp" style={{ backgroundColor: "#f8d408", color: "black", cursor: "pointer", padding: "0.2em 1.6em 0.3em", fontSize: "80%" }} >Lookup</span>
                      </label>
                      <div id="the-basics">
                        <input
                          id={'txt_' + this.state.requestColumns[i].ColumnID}
                          name={this.state.requestColumns[i].ColumnID}
                          placeholder={this.state.requestColumns[i].SampleValue.replace(',', '')}
                          type="text"
                          className="form-control loop-elment"
                          title="Transit Code"
                          maxlength={maxlengthnum}
                          // value={this.state.requestColumns[i].Value.replace(',', '')}
                          defaultValue={this.state.requestColumns[i].Value.replace(',', '')}
                          onChange={this.handleChange}
                          onKeyPress={this.AllowOnlyAlphanumeric}
                        />
                      </div>
                    </div>)
                  }

                } else {

                  if (this.state.requestColumns[i].SampleValue.slice(this.state.requestColumns[i].SampleValue.indexOf(";") + 1) == "Numeric") {
                    children.push(<div className="col-md-4 m-t-20">
                      <label>{this.state.requestColumns[i].ColumnName} {valRequired} </label>
                      <div id="the-basics">
                        <input
                          id={'txt_' + this.state.requestColumns[i].ColumnID}
                          name={this.state.requestColumns[i].ColumnID}
                          placeholder={this.state.requestColumns[i].SampleValue.replace(',', '')}
                          type="text"
                          className="form-control loop-elment"
                          title={this.state.requestColumns[i].ColumnName}
                          maxlength={maxlengthnum}
                          //value={this.state.requestColumns[i].Value.replace(',', '')}                      
                          defaultValue={this.state.requestColumns[i].Value.replace(',', '')}
                          onChange={this.handleChange}
                          onKeyPress={this.AllowOnlyNumeric}
                        />
                      </div>
                    </div>)
                  } else {
                    children.push(<div className="col-md-4 m-t-20">
                      <label>{this.state.requestColumns[i].ColumnName} {valRequired}</label>
                      <div id="the-basics">
                        <input
                          id={'txt_' + this.state.requestColumns[i].ColumnID}
                          name={this.state.requestColumns[i].ColumnID}
                          placeholder={this.state.requestColumns[i].SampleValue.replace(',', '')}
                          type="text"
                          className="form-control loop-elment"
                          title={this.state.requestColumns[i].ColumnName}
                          maxlength={maxlengthnum}
                          // value={this.state.requestColumns[i].Value.replace(',', '')}                       
                          defaultValue={this.state.requestColumns[i].Value.replace(',', '')}
                          onChange={this.handleChange}
                          onKeyPress={this.AllowOnlyAlphanumeric}
                        />
                      </div>
                    </div>)
                  }
                }
              }

              //#endregion
            }

          }
        } else {
          // Alert No Request Columns

        }
      }
      else if (this.state.IsPayeeintiate && this.state.requestColumns == null) {
        this.PISessionIssueAlert();
      }

    }
    else {

      if (this.state.verifiedColumns != 'undefined' && this.state.verifiedColumns != null && this.state.verifiedColumns.length > 0) {

        for (let i = 0; i < this.state.verifiedColumns.length; i++) {
          var maxlengthnum = parseInt(this.state.verifiedColumns[i].SampleValue.replace(',', '').replace(/[^0-9]/gi, '')) || 35;
          var valRequired = this.state.verifiedColumns[i].ValueRequired == true ? '*' : '(Optional)';

          //#region Bank Address & Other Info.

          if (this.state.verifiedColumns[i].ColumnID == "PayeeName") {
            children.push(<div className="col-md-4 m-t-20">
              <label>{this.state.verifiedColumns[i].ColumnName} {valRequired}</label>
              <div id="the-basics" style={{ cursor: "not-allowed" }}>
                <input
                  id={'txt_' + this.state.verifiedColumns[i].ColumnID}
                  name={this.state.verifiedColumns[i].ColumnID}
                  placeholder={this.state.verifiedColumns[i].SampleValue.replace(',', '')}
                  type="text"
                  className="form-control loop-elment"
                  title={this.state.verifiedColumns[i].ColumnName}
                  value={this.state.verifiedColumns[i].Value.replace(',', '')}
                  // value={this.state.payeeName}
                  maxlength="35"
                  disabled
                />
              </div>
            </div>)
          } else if (this.state.verifiedColumns[i].ColumnID == "PayeeNickName") {
            children.push(<div className="col-md-4 m-t-20" style={{ display: "none" }}>
              <label>{this.state.verifiedColumns[i].ColumnName} {valRequired}</label>
              <div id="the-basics" style={{ cursor: "not-allowed" }}>
                <input
                  id={'txt_' + this.state.verifiedColumns[i].ColumnID}
                  name={this.state.verifiedColumns[i].ColumnID}
                  placeholder={this.state.verifiedColumns[i].SampleValue.replace(',', '')}
                  type="text"
                  className="form-control loop-elment"
                  title={this.state.verifiedColumns[i].ColumnName}
                  value={this.state.verifiedColumns[i].Value.replace(',', '')}
                  // defaultValue={this.state.nickname}    
                  maxlength="35"
                />
              </div>
            </div>)
          } else if (this.state.verifiedColumns[i].ColumnID == "PayeeEmail") {
            children.push(<div className="col-md-4 m-t-20">
              <label>{this.state.verifiedColumns[i].ColumnName} *
                {/* {valRequired} */}
              </label>
              <div id="the-basics">
                <input
                  id={'txt_' + this.state.verifiedColumns[i].ColumnID}
                  name={this.state.verifiedColumns[i].ColumnID}
                  placeholder={this.state.verifiedColumns[i].SampleValue.replace(',', '')}
                  type="text"
                  className="form-control loop-elment"
                  title={this.state.verifiedColumns[i].ColumnName}
                  maxlength="35"
                  value={this.state.verifiedColumns[i].Value.replace(',', '')}
                  // value={this.state.payeeEmail}
                  // onChange={this.handleChange}   
                  disabled
                />
              </div>
            </div>)
          } else if (this.state.verifiedColumns[i].ColumnID == "PayeeType") {
            if (this.state.verifiedColumns[i].Value.replace(',', '') == "Individual") {
              children.push(<div className="col-md-4 m-t-20">
                <label>{this.state.verifiedColumns[i].ColumnName}</label>
                <div id="bloodhound">
                  <select className="form-control loop-elment" id={'txt_' + this.state.verifiedColumns[i].ColumnID} name={this.state.verifiedColumns[i].ColumnID} title={this.state.verifiedColumns[i].ColumnName}>
                    <option value="Corporate">Corporate</option>
                    <option value="Individual" selected="selected">Individual</option>
                  </select>
                </div>
              </div>)
            } else {
              children.push(<div className="col-md-4 m-t-20">
                <label>{this.state.verifiedColumns[i].ColumnName} </label>
                <div id="bloodhound">
                  <select className="form-control loop-elment" id={'txt_' + this.state.verifiedColumns[i].ColumnID} name={this.state.verifiedColumns[i].ColumnID} title={this.state.verifiedColumns[i].ColumnName}>
                    <option value="Corporate" selected="selected">Corporate</option>
                    <option value="Individual">Individual</option>
                  </select>
                </div>
              </div>)
            }

          } else if (this.state.verifiedColumns[i].ColumnID == "Currency") {
            children.push(<div className="col-md-4 m-t-20">
              <label>{this.state.verifiedColumns[i].ColumnName}</label>
              <div id="the-basics">
                <select className="form-control loop-elment" id={'txt_' + this.state.verifiedColumns[i].ColumnID} title={this.state.verifiedColumns[i].ColumnName} disabled>
                  <option value="">[---- Select ----]</option>
                  {this.state.currencyList.map((curr, ckey) =>
                    curr.value == this.state.currency ?
                      <option ckey={curr.value} value={curr.value} selected>{curr.text}</option> :
                      <option ckey={curr.value} value={curr.value}>{curr.text}</option>
                  )}
                </select>
              </div>
            </div>)

          } else if (this.state.verifiedColumns[i].ColumnID == "CountryCode") {
            children.push(<div className="col-md-4 m-t-20">
              <label htmlFor="country">{this.state.verifiedColumns[i].ColumnName} </label>
              <select className="form-control loop-elment" id={'txt_' + this.state.verifiedColumns[i].ColumnID} title={this.state.verifiedColumns[i].ColumnName} onChange={this.AutoSelectCurrency} disabled>
                <option value="">[---- Select ----]</option>
                {this.state.countryList.map((country, cckey) =>
                  country.value == this.state.verifiedColumns[i].Value.replace(',', '') ?
                    <option cckey={country.value} value={country.value} selected>{country.text}</option> :
                    <option cckey={country.value} value={country.value}>{country.text}</option>
                )}
              </select>
            </div>)
          } else if (this.state.verifiedColumns[i].ColumnID == "BeneficiaryCountryCode") {
            children.push(<div className="col-md-4 m-t-20">
              <label htmlFor="country">{this.state.verifiedColumns[i].ColumnName}</label>
              <select className="form-control loop-elment" id={'txt_' + this.state.verifiedColumns[i].ColumnID} title={this.state.verifiedColumns[i].ColumnName} onChange={this.Bind_ProvinceList}>
                <option value="">[---- Select ----]</option>
                {this.state.countryList.map((country, bcckey) =>
                  country.value == this.state.verifiedColumns[i].Value.replace(',', '') ?
                    <option bcckey={country.value} value={country.value} selected>{country.text}</option> :
                    <option bcckey={country.value} value={country.value}>{country.text}</option>
                )}
              </select>
            </div>)
          } else if (this.state.verifiedColumns[i].ColumnID == "PayeeBankCountryCode") {
            children.push(<div className="col-md-4 m-t-20">
              <label htmlFor="country">{this.state.verifiedColumns[i].ColumnName}</label>
              <select className="form-control loop-elment" id={'txt_' + this.state.verifiedColumns[i].ColumnID} title={this.state.verifiedColumns[i].ColumnName}>
                <option value="">[---- Select ----]</option>
                {this.state.countryList.map((country, bcckey) =>
                  country.value == this.state.verifiedColumns[i].Value.replace(',', '') ?
                    <option bcckey={country.value} value={country.value} selected>{country.text}</option> :
                    <option bcckey={country.value} value={country.value}>{country.text}</option>
                )}
              </select>
            </div>)
          } else if (this.state.verifiedColumns[i].ColumnID == "BeneficiaryAddress1") {
            children.push(<div className="col-md-4 m-t-20">
              <label>{this.state.verifiedColumns[i].ColumnName}</label>
              <div id="the-basics">
                <input
                  id={'txt_' + this.state.verifiedColumns[i].ColumnID}
                  name={this.state.verifiedColumns[i].ColumnID}
                  placeholder={this.state.verifiedColumns[i].SampleValue.replace(',', '')}
                  type="text"
                  className="form-control loop-elment"
                  title={this.state.verifiedColumns[i].ColumnName}
                  maxlength="35"
                  // value={this.state.verifiedColumns[i].Value.replace(',', '')}
                  defaultValue={this.state.verifiedColumns[i].Value.replace(',', '')}
                  onChange={this.handleChange}
                  onKeyPress={this.AllowOnlyAlphanumeric}
                />
              </div>
            </div>)
          } else if (this.state.verifiedColumns[i].ColumnID == "BeneficiaryBankAddress2") {
            children.push(<div className="col-md-4 m-t-20">
              <label>{this.state.verifiedColumns[i].ColumnName}</label>
              <div id="the-basics">
                <input
                  id={'txt_' + this.state.verifiedColumns[i].ColumnID}
                  name={this.state.verifiedColumns[i].ColumnID}
                  placeholder={this.state.verifiedColumns[i].SampleValue.replace(',', '')}
                  type="text"
                  className="form-control loop-elment"
                  title={this.state.verifiedColumns[i].ColumnName}
                  maxlength="35"
                  //value={this.state.verifiedColumns[i].Value.replace(',', '')}
                  defaultValue={this.state.verifiedColumns[i].Value.replace(',', '')}
                  onChange={this.handleChange}
                  onKeyPress={this.AllowOnlyAlphanumeric}
                />
              </div>
            </div>)
          } else if (this.state.verifiedColumns[i].ColumnID == "BeneficiaryCity") {
            children.push(<div className="col-md-4 m-t-20">
              <label>{this.state.verifiedColumns[i].ColumnName}</label>
              <div id="the-basics">
                <input
                  id={'txt_' + this.state.verifiedColumns[i].ColumnID}
                  name={this.state.verifiedColumns[i].ColumnID}
                  placeholder={this.state.verifiedColumns[i].SampleValue.replace(',', '')}
                  type="text"
                  className="form-control loop-elment"
                  title={this.state.verifiedColumns[i].ColumnName}
                  maxlength="35"
                  //value={this.state.verifiedColumns[i].Value.replace(',', '')}
                  defaultValue={this.state.verifiedColumns[i].Value.replace(',', '')}
                  onChange={this.handleChange}
                  onKeyPress={this.AllowOnlyAlphanumeric}
                />
              </div>
            </div>)
          } else if (this.state.verifiedColumns[i].ColumnID == "BeneficiaryProvince") {
            children.push(<div className="col-md-4 m-t-20 clsProvince">
              <label>{this.state.verifiedColumns[i].ColumnName}</label>
              <div id="the-basics">
                <input
                  id={'txt_' + this.state.verifiedColumns[i].ColumnID}
                  name={this.state.verifiedColumns[i].ColumnID}
                  placeholder={this.state.verifiedColumns[i].SampleValue.replace(',', '')}
                  type="text"
                  className="form-control loop-elment"
                  title={this.state.verifiedColumns[i].ColumnName}
                  maxlength="35"
                  // value={this.state.verifiedColumns[i].Value.replace(',', '')}
                  defaultValue={this.state.verifiedColumns[i].Value.replace(',', '')}
                  onChange={this.handleChange}
                  onKeyPress={this.AllowOnlyAlphanumeric}
                />
              </div>
            </div>)
          } else if (this.state.verifiedColumns[i].ColumnID == "PostalCode") {
            children.push(<div className="col-md-4 m-t-20">
              <label>{this.state.verifiedColumns[i].ColumnName}</label>
              <div id="the-basics">
                <input
                  id={'txt_' + this.state.verifiedColumns[i].ColumnID}
                  name={this.state.verifiedColumns[i].ColumnID}
                  placeholder={this.state.verifiedColumns[i].SampleValue.replace(',', '')}
                  type="text"
                  className="form-control loop-elment"
                  title={this.state.verifiedColumns[i].ColumnName}
                  maxlength="35"
                  //value={this.state.verifiedColumns[i].Value.replace(',', '')}
                  defaultValue={this.state.verifiedColumns[i].Value.replace(',', '')}
                  onChange={this.handleChange}
                  onKeyPress={this.AllowOnlyAlphanumeric}
                />
              </div>
            </div>)
          } else if (this.state.verifiedColumns[i].ColumnID == "PayeeBankName") {
            children.push(<div className="col-md-4 m-t-20">
              <label>{this.state.verifiedColumns[i].ColumnName}</label>
              <div id="the-basics">
                <input
                  id={'txt_' + this.state.verifiedColumns[i].ColumnID}
                  name={this.state.verifiedColumns[i].ColumnID}
                  placeholder={this.state.verifiedColumns[i].SampleValue.replace(',', '')}
                  type="text"
                  className="form-control loop-elment"
                  title={this.state.verifiedColumns[i].ColumnName}
                  maxlength="35"
                  //value={this.state.verifiedColumns[i].Value.replace(',', '')}
                  defaultValue={this.state.verifiedColumns[i].Value.replace(',', '')}
                  onChange={this.handleChange}
                  onKeyPress={this.AllowOnlyAlphanumeric}
                />
              </div>
            </div>)
          } else if (this.state.verifiedColumns[i].ColumnID == "PayeeAddress1") {
            children.push(<div className="col-md-4 m-t-20">
              <label>{this.state.verifiedColumns[i].ColumnName}</label>
              <div id="the-basics">
                <input
                  id={'txt_' + this.state.verifiedColumns[i].ColumnID}
                  name={this.state.verifiedColumns[i].ColumnID}
                  placeholder={this.state.verifiedColumns[i].SampleValue.replace(',', '')}
                  type="text"
                  className="form-control loop-elment"
                  title={this.state.verifiedColumns[i].ColumnName}
                  maxlength="35"
                  //value={this.state.verifiedColumns[i].Value.replace(',', '')}
                  defaultValue={this.state.verifiedColumns[i].Value.replace(',', '')}
                  onChange={this.handleChange}
                  onKeyPress={this.AllowOnlyAlphanumeric}
                />
              </div>
            </div>)
          } else if (this.state.verifiedColumns[i].ColumnID == "PayeeBankAddress2") {
            children.push(<div className="col-md-4 m-t-20">
              <label>{this.state.verifiedColumns[i].ColumnName}</label>
              <div id="the-basics">
                <input
                  id={'txt_' + this.state.verifiedColumns[i].ColumnID}
                  name={this.state.verifiedColumns[i].ColumnID}
                  placeholder={this.state.verifiedColumns[i].SampleValue.replace(',', '')}
                  type="text"
                  className="form-control loop-elment"
                  title={this.state.verifiedColumns[i].ColumnName}
                  maxlength="35"
                  //value={this.state.verifiedColumns[i].Value.replace(',', '')}
                  defaultValue={this.state.verifiedColumns[i].Value.replace(',', '')}
                  onChange={this.handleChange}
                  onKeyPress={this.AllowOnlyAlphanumeric}
                />
              </div>
            </div>)
          } else if (this.state.verifiedColumns[i].ColumnID == "PayeeBankCity") {
            children.push(<div className="col-md-4 m-t-20">
              <label>{this.state.verifiedColumns[i].ColumnName}</label>
              <div id="the-basics">
                <input
                  id={'txt_' + this.state.verifiedColumns[i].ColumnID}
                  name={this.state.verifiedColumns[i].ColumnID}
                  placeholder={this.state.verifiedColumns[i].SampleValue.replace(',', '')}
                  type="text"
                  className="form-control loop-elment"
                  title={this.state.verifiedColumns[i].ColumnName}
                  maxlength="35"
                  //value={this.state.verifiedColumns[i].Value.replace(',', '')}
                  defaultValue={this.state.verifiedColumns[i].Value.replace(',', '')}
                  onChange={this.handleChange}
                  onKeyPress={this.AllowOnlyAlphanumeric}
                />
              </div>
            </div>)
          } else if (this.state.verifiedColumns[i].ColumnID == "Payee BankProvince") {
            children.push(<div className="col-md-4 m-t-20">
              <label>{this.state.verifiedColumns[i].ColumnName}</label>
              <div id="the-basics">
                <input
                  id={'txt_' + this.state.verifiedColumns[i].ColumnID}
                  name={this.state.verifiedColumns[i].ColumnID}
                  placeholder={this.state.verifiedColumns[i].SampleValue.replace(',', '')}
                  type="text"
                  className="form-control loop-elment"
                  title={this.state.verifiedColumns[i].ColumnName}
                  maxlength="35"
                  //value={this.state.verifiedColumns[i].Value.replace(',', '')}
                  defaultValue={this.state.verifiedColumns[i].Value.replace(',', '')}
                  onChange={this.handleChange}
                  onKeyPress={this.AllowOnlyAlphanumeric}
                />
              </div>
            </div>)
          } else if (this.state.verifiedColumns[i].ColumnID == "PostalBankCode") {
            children.push(<div className="col-md-4 m-t-20">
              <label>{this.state.verifiedColumns[i].ColumnName}</label>
              <div id="the-basics">
                <input
                  id={'txt_' + this.state.verifiedColumns[i].ColumnID}
                  name={this.state.verifiedColumns[i].ColumnID}
                  placeholder={this.state.verifiedColumns[i].SampleValue.replace(',', '')}
                  type="text"
                  className="form-control loop-elment"
                  title={this.state.verifiedColumns[i].ColumnName}
                  maxlength="35"
                  // value={this.state.verifiedColumns[i].Value.replace(',', '')}
                  defaultValue={this.state.verifiedColumns[i].Value.replace(',', '')}
                  onChange={this.handleChange}
                  onKeyPress={this.AllowOnlyAlphanumeric}
                />
              </div>
            </div>)
          } else if (this.state.verifiedColumns[i].ColumnName == "Swift Code") {
            // $('#txtRoutingType').val('1');
            children.push(<div className="col-md-4 m-t-20">
              <input type="hidden" id="RoutingType" name="RoutingType" value="1"></input>
              <label onClick={this.HideAdvSearch}>{this.state.verifiedColumns[i].ColumnName}
                &nbsp;<span className="MainNavText label label-warning" id="MainNavHelp" style={{ backgroundColor: "#f8d408", color: "black", cursor: "pointer", padding: "0.2em 1.6em 0.3em", fontSize: "80%" }} >Lookup</span>
              </label>
              <div id="the-basics">
                <input
                  id={'txt_' + this.state.verifiedColumns[i].ColumnID}
                  name={this.state.verifiedColumns[i].ColumnID}
                  placeholder={this.state.verifiedColumns[i].SampleValue.replace(',', '')}
                  type="text"
                  className="form-control loop-elment"
                  title={this.state.verifiedColumns[i].ColumnName}
                  maxlength={maxlengthnum}
                  //value={this.state.verifiedColumns[i].Value.replace(',', '')}
                  defaultValue={this.state.verifiedColumns[i].Value.replace(',', '')}
                  onChange={this.handleChange}
                  onKeyPress={this.AllowOnlyAlphanumeric}
                />
              </div>
            </div>)

          } else if (this.state.verifiedColumns[i].ColumnID == "BankCode") {
            children.push(<div className="col-md-4 m-t-20">
              <label>{this.state.verifiedColumns[i].ColumnName} {valRequired} </label>
              <div id="the-basics">
                <input
                  id={'txt_' + this.state.verifiedColumns[i].ColumnID}
                  name={this.state.verifiedColumns[i].ColumnID}
                  placeholder={this.state.verifiedColumns[i].SampleValue.replace(',', '')}
                  type="text"
                  className="form-control loop-elment"
                  title={this.state.verifiedColumns[i].ColumnName}
                  maxlength={maxlengthnum}
                  //value={this.state.verifiedColumns[i].Value.replace(',', '')}
                  defaultValue={this.state.verifiedColumns[i].Value.replace(',', '')}
                  onChange={this.handleChange}
                  onKeyPress={this.AllowOnlyAlphanumeric}
                />
              </div>
            </div>)
          } else if (this.state.verifiedColumns[i].ColumnName == "ABA") {
            // $('#txtRoutingType').val('10');
            children.push(<div className="col-md-4 m-t-20">
              <input type="hidden" id="RoutingType" name="RoutingType" value="10"></input>
              <label onClick={this.HideAdvSearch}>{this.state.verifiedColumns[i].ColumnName} {valRequired}
                &nbsp;<span className="MainNavText label label-warning" id="MainNavHelp" style={{ backgroundColor: "#f8d408", color: "black", cursor: "pointer", padding: "0.2em 1.6em 0.3em", fontSize: "80%" }} >Lookup</span>
              </label>
              <div id="the-basics">
                <input
                  id={'txt_' + this.state.verifiedColumns[i].ColumnID}
                  name={this.state.verifiedColumns[i].ColumnID}
                  placeholder={this.state.verifiedColumns[i].SampleValue.replace(',', '')}
                  type="text"
                  className="form-control loop-elment"
                  title={this.state.verifiedColumns[i].ColumnName}
                  maxlength={maxlengthnum}
                  //value={this.state.verifiedColumns[i].Value.replace(',', '')}
                  defaultValue={this.state.verifiedColumns[i].Value.replace(',', '')}
                  onChange={this.handleChange}
                  onKeyPress={this.AllowOnlyAlphanumeric}
                />
              </div>
            </div>)
          } else if (this.state.verifiedColumns[i].ColumnID == "ReasonForPayment") {
            children.push(<div className="col-md-4 m-t-20">
              <label>Reference Information/Purpose of Payment' {valRequired} </label>
              <div id="the-basics">
                <input
                  id={'txt_' + this.state.verifiedColumns[i].ColumnID}
                  name={this.state.verifiedColumns[i].ColumnID}
                  placeholder={this.state.verifiedColumns[i].SampleValue.replace(',', '')}
                  type="text"
                  className="form-control loop-elment"
                  title={this.state.verifiedColumns[i].ColumnName}
                  maxlength={maxlengthnum}
                  //value={this.state.verifiedColumns[i].Value.replace(',', '')}
                  defaultValue={this.state.verifiedColumns[i].Value.replace(',', '')}
                  onChange={this.handleChange}
                  onKeyPress={this.AllowOnlyAlphanumeric}
                />
              </div>
            </div>)
          } else {
            if (this.state.verifiedColumns[i].ColumnName == "TRANSIT") {
              //$('#txtRoutingType').val('9');
              if (this.state.verifiedColumns[i].SampleValue.slice(this.state.verifiedColumns[i].SampleValue.indexOf(";") + 1) == "Numeric") {
                children.push(<div className="col-md-4 m-t-20">
                  <input type="hidden" id="RoutingType" name="RoutingType" value="9"></input>
                  <label onClick={this.HideAdvSearch}>Transit Code {valRequired}
                    &nbsp;<span className="MainNavText label label-warning" id="MainNavHelp" style={{ backgroundColor: "#f8d408", color: "black", cursor: "pointer", padding: "0.2em 1.6em 0.3em", fontSize: "80%" }} >Lookup</span>
                  </label>
                  <div id="the-basics">
                    <input
                      id={'txt_' + this.state.verifiedColumns[i].ColumnID}
                      name={this.state.verifiedColumns[i].ColumnID}
                      placeholder={this.state.verifiedColumns[i].SampleValue.replace(',', '')}
                      type="text"
                      className="form-control loop-elment"
                      title="Transit Code"
                      maxlength={maxlengthnum}
                      //value={this.state.verifiedColumns[i].Value.replace(',', '')}
                      defaultValue={this.state.verifiedColumns[i].Value.replace(',', '')}
                      onChange={this.handleChange}
                      onKeyPress={this.AllowOnlyNumeric}
                    />
                  </div>
                </div>)
              } else {
                children.push(<div className="col-md-4 m-t-20">
                  <label onClick={this.HideAdvSearch}>Transit Code {valRequired}
                    &nbsp;<span className="MainNavText label label-warning" id="MainNavHelp" style={{ backgroundColor: "#f8d408", color: "black", cursor: "pointer", padding: "0.2em 1.6em 0.3em", fontSize: "80%" }} >Lookup</span>
                  </label>
                  <div id="the-basics">
                    <input
                      id={'txt_' + this.state.verifiedColumns[i].ColumnID}
                      name={this.state.verifiedColumns[i].ColumnID}
                      placeholder={this.state.verifiedColumns[i].SampleValue.replace(',', '')}
                      type="text"
                      className="form-control loop-elment"
                      title="Transit Code"
                      maxlength={maxlengthnum}
                      //value={this.state.verifiedColumns[i].Value.replace(',', '')}
                      defaultValue={this.state.verifiedColumns[i].Value.replace(',', '')}
                      onChange={this.handleChange}
                      onKeyPress={this.AllowOnlyAlphanumeric}
                    />
                  </div>
                </div>)
              }

            } else {
              if (this.state.verifiedColumns[i].SampleValue.slice(this.state.verifiedColumns[i].SampleValue.indexOf(";") + 1) == "Numeric") {
                children.push(<div className="col-md-4 m-t-20">
                  <label>{this.state.verifiedColumns[i].ColumnName} {valRequired} </label>
                  <div id="the-basics">
                    <input
                      id={'txt_' + this.state.verifiedColumns[i].ColumnID}
                      name={this.state.verifiedColumns[i].ColumnID}
                      placeholder={this.state.verifiedColumns[i].SampleValue.replace(',', '')}
                      type="text"
                      className="form-control loop-elment"
                      title={this.state.verifiedColumns[i].ColumnName}
                      maxlength={maxlengthnum}
                      // value={this.state.verifiedColumns[i].Value.replace(',', '')}
                      defaultValue={this.state.verifiedColumns[i].Value.replace(',', '')}
                      onChange={this.handleChange}
                      onKeyPress={this.AllowOnlyNumeric}
                    />
                  </div>
                </div>)
              } else {
                children.push(<div className="col-md-4 m-t-20">
                  <label>{this.state.verifiedColumns[i].ColumnName} {valRequired}</label>
                  <div id="the-basics">
                    <input
                      id={'txt_' + this.state.verifiedColumns[i].ColumnID}
                      name={this.state.verifiedColumns[i].ColumnID}
                      placeholder={this.state.verifiedColumns[i].SampleValue.replace(',', '')}
                      type="text"
                      className="form-control loop-elment"
                      title={this.state.verifiedColumns[i].ColumnName}
                      maxlength={maxlengthnum}
                      //value={this.state.verifiedColumns[i].Value.replace(',', '')}
                      defaultValue={this.state.verifiedColumns[i].Value.replace(',', '')}
                      onChange={this.handleChange}
                      onKeyPress={this.AllowOnlyAlphanumeric}
                    />
                  </div>
                </div>)
              }
            }
          }

          //#endregion

        }

      } else {
        // Alert No Request Columns
      }
    }


    table.push(<div className="row">{children}</div>)

    return table
  }

  render() {
    let dataBank = this.state.bankData;

    const data = {
      columns: [
        {
          label: 'Select',
          field: 'SELECT',
          width: 50
        },
        {
          label: 'Bank Details',
          field: 'Bank',
          sort: 'asc',
          width: 100
        },
        {
          label: 'Bank Name',
          field: 'NAME',
          sort: 'asc',
          width: 150
        },
        {
          label: 'Routing Code',
          field: 'BankCode',
          sort: 'asc',
          width: 270
        },
        // {
        //   label: 'Routing Code',
        //   field: 'ROUTINGCODE',
        //   sort: 'asc',
        //   width: 270
        // },
        {
          label: 'Bank Code',
          field: 'BANK_CODE',
          sort: 'asc',
          width: 200
        },
        {
          label: 'Country',
          field: 'COUNTRY_NAME',
          sort: 'asc',
          width: 100
        },
        {
          label: 'Address1',
          field: 'ADDRESS1',
          sort: 'asc',
          width: 150
        },
        {
          label: 'City',
          field: 'CITY',
          sort: 'asc',
          width: 100
        },
        {
          label: 'Province',
          field: 'PROVINCE',
          sort: 'asc',
          width: 100
        },
        {
          label: 'Postal Code/Zip Code',
          field: 'POSTCODE',
          sort: 'asc',
          width: 100
        },
        {
          label: 'Routing Type',
          field: 'RoutingTypeNameNotNull',
          sort: 'asc',
          width: 100
        }
      ],
      rows: dataBank
    };

    const MyModel = (props) => (<Modal show={props.isHidden} onHide={props.onClose} size="md" aria-labelledby="contained-modal-title-vcenter">
      <Modal.Header closeButton>
        <Modal.Title>Lookup Bank Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <MDBDataTable
          responsive
          striped
          bordered
          hover
          data={data}
          className="MdbTable"
          searching={true}
          paging={false}
        />
      </Modal.Body>
      <Modal.Footer>
        {/* <Button onClick={props.onClose}>Close</Button> */}
      </Modal.Footer>
    </Modal>);
    return (     
      <><Header requestID={this.state.requestID} clientID={this.state.clientID} payeeEmail={this.state.payeeEmail} entityName={this.state.entityName} payeeName={this.state.payeeName} />
        <div className="container-fluid page-body-wrapper">
          <div className="main-panel">
            <div className="content-wrapper">
              <div className="row">
                <div className="col-12 grid-margin">
                  <div className="card">
                    <div className="card-body">
                      <h4 className="card-title">&nbsp;</h4>
                      <form onSubmit={this.submitAccount}>

                        {this.state.loading === true ? <div class="overlay"> </div> : ''}
                        <BallClipRotate color={'#123abc'} loading={this.state.loading} />

                        <section>
                          <div className="wizard">
                            <div className="row">
                              <div className="col-md-3">
                                <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                                  {this.DynamicTabs()}
                                </div>
                              </div>
                              <div className="col-md-9">
                                <div className="content clearfix">
                                  {this.state.headerTitle === '' ? <h3 className="font-green">Name & Account Number</h3> :
                                    <h3 className="font-green">{this.state.headerTitle}</h3>
                                  }
                                  <div className="">
                                    {
                                      <div className="container-fluid" id="CreateTableDynamicID" ref="CreateTableDynamicID">
                                        {/* {
                                          this.state.step == 2 ?
                                            <>
                                              <div className="row">
                                                <div className="col-md-4" id="idCreateTableDynamicBankInformation">
                                                  <h3 className="font-green">Bank Information</h3>
                                                  {this.CreateTableDynamicBankInformation()}
                                                </div>


                                                <div className="col-md-5" id="idCreateTableDynamicYourAddress">
                                                  <h3 className="font-green">Your Address</h3>
                                                  {this.CreateTableDynamicYourAddress()}
                                                </div>
                                              </div>
                                            </>
                                            :
                                            <div className="col-md-12" id="idCreateTableDynamic">
                                              {this.CreateTableDynamic()}
                                            </div>

                                        } */}
                                        {this.CreateTableDynamic()}

                                      </div>
                                    }
                                  </div>
                                </div>
                              </div>

                            </div>
                          </div>

                          {this.ShowButtonsDynamic()}

                        </section>
                        <div>
                          <MyModel isHidden={this.state.showModal} onClose={this.hideModal} />
                          {/* <Button className="btn btn-primary m-1" onClick={this.showModal}>Show modal</Button> */}
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />

      </>
    )
  }
}

export default Managebankaccount
